import { LocationWithLanes } from '@clear-denver/tpc-bff-client/build/api/tpc-bff/types'

export const activeLocations: LocationWithLanes[] = [
  {
    uid: 'SP0815',
    name: 'Staples - Akron, OH',
    address1: '4014 Medina Road',
    address2: null,
    zip: '44333',
    city: 'Akron',
    state: 'OH',
    country: 'USA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    importantInfo: null,
    open: false,
    latitude: 41.1358,
    longitude: -81.6436,
    serviceTerritoryId: '0Hhcr0000000fETCAY',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'SP0815',
        name: null,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo:
          'Memorial Day Hours of Operation: 10:10am - 1:00pm, 1:30pm - 5:00pm',
        availability: [
          {
            days: 'Monday - Friday',
            hours: '9:10am - 1:00pm, 1:30pm - 5:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'SP1243',
    name: 'Staples - Wheaton, MD',
    address1: '12389 Georgia Ave',
    address2: null,
    zip: '20906',
    city: 'Wheaton',
    state: 'MD',
    country: 'USA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    importantInfo: null,
    open: false,
    latitude: 39.06104,
    longitude: -77.0502,
    serviceTerritoryId: '0Hhcr0000000jy1CAA',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'SP1243',
        name: null,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo: 'Closed 5/26',
        availability: [
          {
            days: 'Monday - Friday',
            hours: '9:10am - 1:00pm, 1:30pm - 5:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'SP0855',
    name: 'Staples - Strongsville, OH',
    address1: '12421 Pearl Road',
    address2: null,
    zip: '44136',
    city: 'Strongsville',
    state: 'OH',
    country: 'USA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    importantInfo: null,
    open: false,
    latitude: 41.3228,
    longitude: -81.8352,
    serviceTerritoryId: '0Hhcr0000000fG5CAI',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'SP0855',
        name: null,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo: 'Closed 5/26',
        availability: [
          {
            days: 'Monday - Friday',
            hours: '9:10am - 1:00pm, 1:30pm - 5:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'iad',
    name: 'Washington Dulles International Airport - IAD',
    address1: '1 Saarinen Cir',
    address2: null,
    zip: '20166',
    city: 'Dulles',
    state: 'VA',
    country: 'USA',
    type: 'airport',
    parking:
      'Parking is located across from the terminal. Hourly and daily parking are available. Onsite and offsite parking are also available.',
    importantInfo: null,
    open: true,
    latitude: 38.9523,
    longitude: -77.4586,
    serviceTerritoryId: '0Hhcr0000000a0HCAQ',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'iad',
        name: 'Main Terminal',
        description:
          'Located near TSA PreCheck screening side on the Departures level. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: false,
        accessibilityMessage:
          'Accessible pod is available at Main Terminal - East Standard Screening Side',
        availability: [
          {
            days: null,
            hours: '6:00am - 9:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'MYH',
    name: 'CLEAR Moynihan Train Hall',
    address1: '350 W 33rd St',
    address2: null,
    zip: '10001',
    city: 'New York',
    state: 'NY',
    country: 'USA',
    type: 'flagship',
    parking: '',
    importantInfo: null,
    open: false,
    latitude: 40.7519,
    longitude: -73.9955,
    serviceTerritoryId: '0Hhcr0000000coTCAQ',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'MYH',
        name: null,
        description:
          'Located on the ground level of Moynihan Train Hall by Track 5 and 6, in front of the Amtrak Metropolitan Lounge. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo: null,
        availability: [
          {
            days: 'Monday - Friday',
            hours: '8:00am - 6:00pm',
          },
          {
            days: 'Saturday - Sunday',
            hours: '10:00am - 5:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'mdw',
    name: 'Chicago Midway International Airport - MDW',
    address1: '5700 S Cicero Ave',
    address2: null,
    zip: '60638',
    city: 'Chicago',
    state: 'IL',
    country: 'USA',
    type: 'airport',
    parking:
      'Parking is located across from the terminal. Hourly and daily parking are available. Onsite and offsite parking are also available.',
    importantInfo: null,
    open: true,
    latitude: 41.7868,
    longitude: -87.7522,
    serviceTerritoryId: '0Hhcr0000000awLCAQ',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'mdw',
        name: 'Main Terminal',
        description:
          'Located on the Mezzanine level near North security checkpoint bridge. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo: null,
        availability: [
          {
            days: null,
            hours: '6:00am - 8:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'SP1034',
    name: 'Staples - Orlando, FL',
    address1: '2774 East Colonial Drive',
    address2: 'Suite C',
    zip: '32803',
    city: 'Orlando',
    state: 'FL',
    country: 'USA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    importantInfo: '',
    open: false,
    latitude: 28.5502,
    longitude: -81.3486,
    serviceTerritoryId: '0Hhcr0000000iDxCAI',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'SP1034',
        name: null,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo:
          'Memorial Day Hours of Operation: 10:10am - 1:00pm, 1:30pm - 5:00pm',
        availability: [
          {
            days: 'Monday - Tuesday, Thursday & Friday',
            hours: '9:10am - 1:00pm, 1:30pm - 5:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'ogg',
    name: 'Kahului Airport - OGG',
    address1: '1 Keolani Pl',
    address2: null,
    zip: '96732',
    city: 'Kahului',
    state: 'HI',
    country: 'USA',
    type: 'airport',
    parking:
      'Parking is located across from the terminal. Hourly and daily parking are available. Onsite and offsite parking are also available.',
    importantInfo: null,
    open: true,
    latitude: 20.8946,
    longitude: -156.4361,
    serviceTerritoryId: '0Hhcr0000000bPNCAY',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'ogg',
        name: 'Main Terminal',
        description:
          "Located in the main terminal across from airlines' ticketing counters, near the security checkpoint. Look for TSA PreCheck and CLEAR signage.",
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo: null,
        availability: [
          {
            days: null,
            hours: '6:00am - 2:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'SP1910',
    name: 'Staples - Tucker, GA - Planned Opening May 27th',
    address1: '4351 Hugh Howell Rd',
    address2: null,
    zip: '30084',
    city: 'Tucker',
    state: 'GA',
    country: 'USA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    importantInfo: null,
    open: false,
    latitude: 33.8507,
    longitude: -84.2096,
    serviceTerritoryId: '',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'SP1910',
        name: null,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo: null,
        availability: [
          {
            days: 'Monday - Friday',
            hours: '9:10am - 1:00pm, 1:30pm - 5:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'SP0142',
    name: 'Staples - Valley Stream, NY',
    address1: '80 W. Sunrise Hwy Valley',
    address2: null,
    zip: '11581',
    city: 'Stream',
    state: 'NY',
    country: 'USA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    importantInfo: null,
    open: false,
    latitude: 40.66007,
    longitude: -73.70402,
    serviceTerritoryId: '0Hhcr0000000eThCAI',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'SP0142',
        name: null,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo: 'Closed 5/26 & 6/13',
        availability: [
          {
            days: 'Monday - Friday',
            hours: '9:10am - 1:00pm, 1:30pm - 5:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'HPN',
    name: 'Westchester County Airport - HPN',
    address1: '240 Airport Rd',
    address2: null,
    zip: '10604',
    city: 'West Harrison',
    state: 'NY',
    country: 'USA',
    type: 'airport',
    parking:
      'Parking is located across from the terminal. Hourly and daily parking are available. Onsite and offsite parking are also available.',
    importantInfo: null,
    open: true,
    latitude: 41.0685,
    longitude: -73.7041,
    serviceTerritoryId: '0Hhcr0000000a9xCAA',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'HPN',
        name: 'Main Terminal',
        description:
          'Located on the ground floor near the baggage claim area. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo: null,
        availability: [
          {
            days: 'Monday - Friday',
            hours: '5:00am - 1:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'SP1128',
    name: 'Staples - Southport, IN',
    address1: '5140 East Southport Rd',
    address2: null,
    zip: '20716',
    city: 'Southport',
    state: 'IN',
    country: 'USA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    importantInfo: null,
    open: false,
    latitude: 39.66704,
    longitude: -86.0811,
    serviceTerritoryId: '0Hhcr0000000aMrCAI',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'SP1128',
        name: null,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo:
          'Memorial Day Hours of Operation: 10:10am - 1:00pm, 1:30pm - 5:00pm',
        availability: [
          {
            days: 'Monday - Friday',
            hours: '9:10am - 1:00pm, 1:30pm - 5:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'SFT',
    name: 'CLEAR Salesforce Transit Center',
    address1: '425 Mission St',
    address2: null,
    zip: '94105',
    city: 'San Francisco',
    state: 'CA',
    country: 'USA',
    type: 'flagship',
    parking:
      'Parking is located across from the terminal. Hourly and daily parking are available. Onsite and offsite parking are also available.',
    importantInfo: null,
    open: false,
    latitude: 37.7902,
    longitude: -122.3968,
    serviceTerritoryId: '0Hhcr0000000crhCAA',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'SFT',
        name: null,
        description:
          'Located on the ground level of the Salesforce Transit Center. Enter via the Mission and 1st street entrance. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo: 'Closed 5/26',
        availability: [
          {
            days: 'Monday - Friday',
            hours: '8:30am - 12:00pm, 12:30pm - 5:00pm',
          },
          {
            days: 'Saturday - Sunday',
            hours: '10:00am - 3:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'WLC',
    name: 'CLEAR Westlake Center',
    address1: '400 Pine St',
    address2: null,
    zip: '98101',
    city: 'Seattle',
    state: 'WA',
    country: 'USA',
    type: 'flagship',
    parking: '',
    importantInfo: null,
    open: false,
    latitude: 47.6119,
    longitude: -122.3376,
    serviceTerritoryId: '0Hhcr0000000cA9CAI',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'WLC',
        name: null,
        description:
          'Located on the main floor behind the northeast escalator. Enter the mall through the Fifth Avenue entrance and follow the walkway to the escalator. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo: null,
        availability: [
          {
            days: 'Monday - Thursday',
            hours: '11:00am - 3:00pm, 3:30pm - 7:00pm',
          },
          {
            days: 'Sunday',
            hours: '12:00pm - 4:00pm, 4:30pm - 7:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'SP0229',
    name: 'Staples - Largo, FL',
    address1: '13013 Seminole Blvd',
    address2: null,
    zip: '33778',
    city: 'Largo',
    state: 'FL',
    country: 'USA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    importantInfo: null,
    open: false,
    latitude: 27.8921,
    longitude: -82.7864,
    serviceTerritoryId: '0Hhcr0000000fsnCAA',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'SP0229',
        name: null,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo: 'Closed 5/26',
        availability: [
          {
            days: 'Monday, Tuesday, Thursday, and Friday',
            hours: '9:10am - 1:00pm, 1:30pm - 5:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'SP0207',
    name: 'Staples - Columbia, MD',
    address1: '9091 Snowden River Pkwy',
    address2: null,
    zip: '21046',
    city: 'Columbia',
    state: 'MD',
    country: 'USA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    importantInfo: null,
    open: false,
    latitude: 39.1816,
    longitude: -76.8218,
    serviceTerritoryId: '0Hhcr0000000fmLCAQ',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'SP0207',
        name: null,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo: 'Closed 5/26',
        availability: [
          {
            days: 'Monday - Friday',
            hours: '9:10am - 1:00pm, 1:30pm - 5:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'SP0707',
    name: 'Staples - South Plainfield, NJ',
    address1: '7000 Hadley Rd South',
    address2: null,
    zip: '07080',
    city: 'Plainfield',
    state: 'NJ',
    country: 'USA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    importantInfo: '',
    open: false,
    latitude: 40.5543,
    longitude: -74.43203,
    serviceTerritoryId: '0Hhcr0000001JGjCAM',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'SP0707',
        name: null,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo: 'Closed 5/26',
        availability: [
          {
            days: 'Monday - Friday',
            hours: '9:10am - 1:00pm, 1:30pm - 5:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'SP0092',
    name: 'Staples - Falls Church, VA',
    address1: '1104 West Broad St Falls',
    address2: null,
    zip: '22064',
    city: 'Church',
    state: 'VA',
    country: 'USA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    importantInfo: null,
    open: false,
    latitude: 38.8932,
    longitude: -77.1868,
    serviceTerritoryId: '0Hhcr0000000iM1CAI',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'SP0092',
        name: null,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo:
          'Memorial Day Hours of Operation: 10:10am - 1:00pm, 1:30pm - 5:00pm',
        availability: [
          {
            days: 'Monday - Friday',
            hours: '9:10am - 1:00pm, 1:30pm - 5:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'SP1799',
    name: 'Staples - Pittsburgh, PA - Penn Ave',
    address1: '6375 Penn Ave',
    address2: null,
    zip: '15205',
    city: 'Pittsburgh',
    state: 'PA',
    country: 'USA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    importantInfo: null,
    open: false,
    latitude: 40.459,
    longitude: -79.9174,
    serviceTerritoryId: '0Hhcr0000000U1JCAU',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'SP1799',
        name: null,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo:
          'Memorial Day Hours of Operation: 10:10am - 1:00pm, 1:30pm - 5:00pm',
        availability: [
          {
            days: 'Monday & Friday',
            hours: '9:10am - 1:00pm, 1:30pm - 5:00pm',
          },
          {
            days: 'Tuesday & Thursday',
            hours: '11:00am - 3:00pm, 3:30pm - 7:00pm',
          },
          {
            days: 'Wednesday & Sunday',
            hours: 'Closed',
          },
          {
            days: 'Saturday',
            hours: '10:10am - 2:00pm, 2:30pm - 6:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'HGM',
    name: 'CLEAR Houston Galleria',
    address1: '5085 Westheimer Rd',
    address2: null,
    zip: '77056',
    city: 'Houston',
    state: 'TX',
    country: 'USA',
    type: 'flagship',
    parking: 'Parking is available at the mall.',
    importantInfo: null,
    open: true,
    latitude: 29.7393,
    longitude: -95.46505,
    serviceTerritoryId: '0Hhcr0000000c8XCAQ',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'HGM',
        name: null,
        description:
          'Located on Level 1 by the escalator, between the Express and Gap stores of the Galleria Mall. Entrance on West Alabama street, near the Museum of Illusions. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo: null,
        availability: [
          {
            days: 'Monday - Saturday',
            hours: '11:00am - 7:00pm',
          },
          {
            days: 'Sunday',
            hours: '12:00pm - 6:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'dal',
    name: 'Dallas Love Field - DAL',
    address1: '8008 Herb Kelleher Way',
    address2: null,
    zip: '75235',
    city: 'Dallas',
    state: 'TX',
    country: 'USA',
    type: 'airport',
    parking:
      'Parking is located across from the terminal. Hourly and daily parking are available. Onsite and offsite parking are also available.',
    importantInfo: null,
    open: true,
    latitude: 32.848152,
    longitude: -96.851349,
    serviceTerritoryId: '0Hhcr0000000bHJCAY',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'dal',
        name: 'Main Terminal',
        description:
          'Located on the west side of the security checkpoint entrance. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo: null,
        availability: [
          {
            days: 'Sunday - Friday',
            hours: '6:00am - 8:00pm',
          },
          {
            days: 'Saturday',
            hours: '6:00am - 7:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'las',
    name: 'Harry Reid International Airport - LAS',
    address1: '5757 Wayne Newton Blvd',
    address2: null,
    zip: '89119',
    city: 'Las Vegas',
    state: 'NV',
    country: 'USA',
    type: 'airport',
    parking:
      'Parking is located across from the terminal. Hourly and daily parking are available. Onsite and offsite parking are also available.',
    importantInfo: null,
    open: true,
    latitude: 36.083134,
    longitude: -115.148315,
    serviceTerritoryId: '0Hhcr0000000bIvCAI',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'las',
        name: 'Terminal 1',
        description:
          'Located on the second floor near the security checkpoint. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo: null,
        availability: [
          {
            days: null,
            hours: '6:00am - 8:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'SP0012',
    name: 'Staples - Totowa, NJ',
    address1: '545 US Highway 46',
    address2: null,
    zip: '07512',
    city: 'Totowa',
    state: 'NJ',
    country: 'USA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    importantInfo: null,
    open: false,
    latitude: 40.8952,
    longitude: -74.2392,
    serviceTerritoryId: '0Hhcr0000000U4XCAU',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'SP0012',
        name: null,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo: 'Closed 5/26',
        availability: [
          {
            days: 'Monday - Friday',
            hours: '9:10am - 1:00pm, 1:30pm - 5:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'bos',
    name: 'Boston Logan International Airport - BOS',
    address1: '1 Harborside Dr',
    address2: null,
    zip: '02128',
    city: 'Boston',
    state: 'MA',
    country: 'USA',
    type: 'airport',
    parking:
      'Parking is located across from the terminal. Hourly and daily parking are available. Onsite and offsite parking are also available.',
    importantInfo: null,
    open: true,
    latitude: 42.3654,
    longitude: -71.0108,
    serviceTerritoryId: '0Hhcr0000000a1tCAA',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'bos',
        name: 'Terminal A, Security Level',
        description:
          'Located to the right of the security checkpoint entrance near Door A202. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: false,
        accessibilityMessage:
          'Accessible pod is available at Terminal B, Security Level',
        availability: [
          {
            days: null,
            hours: '5:00am - 6:00pm',
          },
        ],
      },
      {
        id: '2',
        locationUid: 'bos',
        name: 'Terminal C, Security Level',
        description:
          'Located near the JetBlue check-in counter and Door C204. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo: null,
        availability: [
          {
            days: null,
            hours: '5:00am - 6:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'pvd',
    name: 'Rhode Island T.F. Green International Airport - PVD',
    address1: '2000 Post Rd.',
    address2: null,
    zip: '02886',
    city: 'Warwick',
    state: 'RI',
    country: 'USA',
    type: 'airport',
    parking:
      'Parking is located across from the terminal. Hourly and daily parking are available. Onsite and offsite parking are also available.',
    importantInfo: null,
    open: true,
    latitude: 41.7217,
    longitude: -71.4295,
    serviceTerritoryId: '0Hhcr0000000WntCAE',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'pvd',
        name: 'Main Terminal',
        description:
          'Located on the Departures level (Level 2) in front of the security checkpoint entrance. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo: null,
        availability: [
          {
            days: null,
            hours: '6:00am - 6:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'SP0726',
    name: 'Staples - Lodi, CA',
    address1: '2415 West Kettleman Lane',
    address2: null,
    zip: '95242',
    city: 'Lodi',
    state: 'CA',
    country: 'USA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    importantInfo: null,
    open: false,
    latitude: 38.11706,
    longitude: -121.3042,
    serviceTerritoryId: '0Hhcr0000000XTpCAM',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'SP0726',
        name: null,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo:
          'Memorial Day Hours of Operation: 10:10am - 1:00pm, 1:30pm - 5:00pm',
        availability: [
          {
            days: 'Monday & Friday',
            hours: '9:10am - 1:00pm, 1:30pm - 5:00pm',
          },
          {
            days: 'Tuesday & Thursday',
            hours: '11:10am - 3:00pm, 3:30pm - 7:00pm',
          },
          {
            days: 'Saturday',
            hours: '10:10am - 1:00pm, 1:30pm - 6:00pm',
          },
          {
            days: 'Wednesday & Sunday',
            hours: 'Closed',
          },
        ],
      },
    ],
  },
  {
    uid: 'TFM',
    name: 'CLEAR The Florida Mall',
    address1: '8001 S Orange Blossom Trl',
    address2: null,
    zip: '32809',
    city: 'Orlando',
    state: 'FL',
    country: 'USA',
    type: 'flagship',
    parking: 'Parking is available at the mall.',
    importantInfo: null,
    open: true,
    latitude: 28.446003,
    longitude: -81.3955,
    serviceTerritoryId: '0Hhcr0000000c6vCAA',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'TFM',
        name: null,
        description:
          "Located on the main floor across from the Tesla store. Enter via the South entrance near Macy's. Proceed straight ahead towards guest services and turn left. Look for TSA PreCheck and CLEAR signage.",
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo: null,
        availability: [
          {
            days: 'Monday - Sunday',
            hours: '11:00am - 7:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'MOA',
    name: 'CLEAR Mall of America',
    address1: '60 E Broadway',
    address2: null,
    zip: '55425',
    city: 'Bloomington',
    state: 'MN',
    country: 'USA',
    type: 'flagship',
    parking: '',
    importantInfo: null,

    open: true,
    latitude: 44.8565,
    longitude: -93.2394,
    serviceTerritoryId: '0Hhcr0000000bXRCAY',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'MOA',
        name: null,
        description:
          'Located on the main floor of Mall of America by the main escalator. Enter via the East parking ramp, turn left at the rotunda, and follow the walkway to the Southeast corner. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo: null,
        availability: [
          {
            days: 'Monday - Saturday',
            hours: '11:00am - 7:00pm',
          },
          {
            days: 'Sunday',
            hours: '11:00am - 6:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'SP1611',
    name: 'Staples - Chicago, IL',
    address1: '111 North Wabash Ave',
    address2: null,
    zip: '60602',
    city: 'Chicago',
    state: 'IL',
    country: 'USA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    importantInfo: null,
    open: false,
    latitude: 41.8834,
    longitude: -87.6256,
    serviceTerritoryId: '0Hhcr0000000fUbCAI',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'SP1611',
        name: null,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo:
          'Memorial Day Hours of Operation: 10:10am - 1:00pm, 1:30pm - 5:00pm',
        availability: [
          {
            days: 'Monday - Friday',
            hours: '9:10am - 1:00pm, 1:30pm - 5:00pm',
          },
          {
            days: 'Saturday',
            hours: '10:10am - 1:30pm, 2:00pm - 5:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'SP1788',
    name: 'Staples - Norridge, IL',
    address1: '7000 West Forest Preserve Dr',
    address2: null,
    zip: '60706',
    city: 'Norridge',
    state: 'IL',
    country: 'USA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    importantInfo: null,
    open: false,
    latitude: 41.9563,
    longitude: -87.8033,
    serviceTerritoryId: '0Hhcr0000000TwTCAU',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'SP1788',
        name: null,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo: 'Closed 5/26',
        availability: [
          {
            days: 'Monday - Friday',
            hours: '9:10am - 1:00pm, 1:30pm - 5:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'SP1825',
    name: 'Staples - Stony Brook, NY',
    address1: '2100 Nesconset',
    address2: null,
    zip: '11790',
    city: 'Stony Brook',
    state: 'NY',
    country: 'USA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    importantInfo: null,
    open: false,
    latitude: 40.8707,
    longitude: -73.1301,
    serviceTerritoryId: '0Hhcr0000000cJpCAI',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'SP1825',
        name: null,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo: 'Closed 5/26',
        availability: [
          {
            days: 'Monday - Thursday',
            hours: '9:10am - 1:00pm, 1:30pm - 5:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'ewr',
    name: 'Newark International Airport - EWR',
    address1: '3 Brewster Rd',
    address2: null,
    zip: '07114',
    city: 'Newark',
    state: 'NJ',
    country: 'USA',
    type: 'airport',
    parking:
      'Parking is located across from the terminal. Hourly and daily parking are available. Onsite and offsite parking are also available.',
    importantInfo: null,
    open: true,
    latitude: 40.6933707748659,
    longitude: -74.18283252766588,
    serviceTerritoryId: '0Hhcr0000000azZCAQ',
    isTestLocation: false,
    lanes: [
      {
        id: '2',
        locationUid: 'ewr',
        name: 'Terminal C',
        description:
          'Located on Level 3, Door 2 overlooking the TSA PreCheck® security checkpoint. Look for TSA PreCheck® and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo: null,
        availability: [
          {
            days: null,
            hours: '6:00am - 8:00pm',
          },
        ],
      },
      {
        id: '1',
        locationUid: 'ewr',
        name: 'Terminal A',
        description:
          'Located to the right of the security checkpoint entrance. Look for TSA PreCheck® and CLEAR pods.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo: null,
        availability: [
          {
            days: null,
            hours: '4:00am - 8:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'SP1491',
    name: 'Staples - Henderson (Green Valley), NV',
    address1: '675 Green Valley Parkway Henderson',
    address2: null,
    zip: '89052',
    city: 'Green Valley',
    state: 'NV',
    country: 'USA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    importantInfo: null,
    open: false,
    latitude: 36.0035,
    longitude: -115.0853,
    serviceTerritoryId: '0Hhcr0000000fSzCAI',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'SP1491',
        name: null,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo: 'Closed 5/26',
        availability: [
          {
            days: 'Monday - Friday',
            hours: '9:10am - 1:00pm, 1:30pm - 5:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'SP0738',
    name: 'Staples - Natomas, CA',
    address1: '3631 Truxel Road',
    address2: null,
    zip: '95834',
    city: 'Natomas',
    state: 'CA',
    country: 'USA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    importantInfo: null,
    open: false,
    latitude: 38.6338,
    longitude: -121.5058,
    serviceTerritoryId: '0Hhcr0000000eezCAA',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'SP0738',
        name: null,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo:
          'Memorial Day Hours of Operation: 10:10am - 1:00pm, 1:30pm - 5:00pm',
        availability: [
          {
            days: 'Monday - Friday',
            hours: '9:10am - 1:00pm, 1:30pm - 5:00pm',
          },
          {
            days: 'Saturday',
            hours: '10:10am - 2:00pm, 2:30pm - 6:00pm',
          },
          {
            days: 'Beginning 5/10',
            hours: null,
          },
          {
            days: 'Monday - Friday',
            hours: '9:10am - 1:00pm, 1:30pm - 5:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'SP1392',
    name: 'Staples - Chandler, AZ',
    address1: '2840 E Germann Rd',
    address2: null,
    zip: '85286',
    city: 'Chandler',
    state: 'AZ',
    country: 'USA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    importantInfo: null,
    open: false,
    latitude: 33.2808,
    longitude: -111.7917,
    serviceTerritoryId: '0Hhcr0000000i7VCAQ',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'SP1392',
        name: null,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo:
          'Memorial Day Hours of Operation: 10:10am - 1:00pm, 1:30pm - 5:00pm',
        availability: [
          {
            days: 'Monday - Friday',
            hours: '9:10am - 1:00pm, 1:30pm - 5:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'SP0827',
    name: 'Staples - Harrisburg, PA',
    address1: '4203 Union Deposit Rd',
    address2: null,
    zip: '17111',
    city: 'Harrisburg',
    state: 'PA',
    country: 'USA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    importantInfo: null,
    open: false,
    latitude: 40.2784,
    longitude: -76.8158,
    serviceTerritoryId: '0Hhcr0000000ertCAA',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'SP0827',
        name: null,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo: 'Closed 5/26',
        availability: [
          {
            days: 'Monday - Friday',
            hours: '9:10am - 1:00pm, 1:30pm - 5:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'hnl',
    name: 'Daniel K. Inouye International Airport - HNL',
    address1: '300 Rodgers Blvd',
    address2: null,
    zip: '96819',
    city: 'Honolulu',
    state: 'HI',
    country: 'USA',
    type: 'airport',
    parking:
      'Parking is located across from the terminal. Hourly and daily parking are available. Onsite and offsite parking are also available.',
    importantInfo: null,
    open: true,
    latitude: 21.3099,
    longitude: -157.8581,
    serviceTerritoryId: '0Hhcr0000000bM9CAI',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'hnl',
        name: 'Terminal 1',
        description:
          'Located near the security checkpoint 1B entrance on Level 2. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo: null,
        availability: [
          {
            days: null,
            hours: '6:00am - 2:00pm',
          },
        ],
      },
      {
        id: '2',
        locationUid: 'hnl',
        name: 'Terminal 2',
        description:
          'Located in front of checkpoint 3 security entrance on the Departures level. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo: null,
        availability: [
          {
            days: null,
            hours: '9:00am - 5:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'SP0784',
    name: 'Staples - Mays Landing, NJ',
    address1: '2300 Wrangleboro Rd Mays',
    address2: null,
    zip: '08330',
    city: 'Landing',
    state: 'NJ',
    country: 'USA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    importantInfo: null,
    open: false,
    latitude: 39.4525,
    longitude: -74.6356,
    serviceTerritoryId: '0Hhcr0000000iPFCAY',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'SP0784',
        name: null,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo:
          'Memorial Day Hours of Operation: 10:10am - 1:00pm, 1:30pm - 5:00pm',
        availability: [
          {
            days: 'Monday - Friday',
            hours: '9:10am - 1:00pm, 1:30pm - 5:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'lax',
    name: 'Los Angeles International Airport - LAX',
    address1: '1 World Way',
    address2: null,
    zip: '90045',
    city: 'Los Angeles',
    state: 'CA',
    country: 'USA',
    type: 'airport',
    parking:
      'Parking is located across from the terminal. Hourly and daily parking are available. Onsite and offsite parking are also available.',
    importantInfo: null,
    open: true,
    latitude: 33.942791,
    longitude: -118.410042,
    serviceTerritoryId: '0Hhcr0000000bKXCAY',
    isTestLocation: false,
    lanes: [
      {
        id: '2',
        locationUid: 'lax',
        name: 'Terminal 7',
        description:
          'Located on Level 2 Departures, across from the security screening area. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: false,
        accessibilityMessage:
          'Accessible pods are available at Terminal 3 East - Standard Screening Side and Terminal 3 West - TSA PreCheck Screening Side',
        availability: [
          {
            days: null,
            hours: '6:00am - 8:00pm',
          },
        ],
      },
      {
        id: '1',
        locationUid: 'lax',
        name: 'Terminal 3, West - TSA PreCheck Screening Side',
        description:
          'Located on the third floor in Delta Terminal near the TSA PreCheck screening side. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo: null,
        availability: [
          {
            days: null,
            hours: '6:00am - 8:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'pit',
    name: 'Pittsburgh International Airport - PIT',
    address1: '1000 Airport Blvd',
    address2: null,
    zip: '15231',
    city: 'Pittsburgh',
    state: 'PA',
    country: 'USA',
    type: 'airport',
    parking:
      'Parking is located across from the terminal. Hourly and daily parking are available. Onsite and offsite parking are also available.',
    importantInfo: null,
    open: true,
    latitude: 40.444,
    longitude: -79.9605,
    serviceTerritoryId: '0Hhcr0000000aOTCAY',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'pit',
        name: 'Main Terminal',
        description:
          'Located landside on the second floor next to the main security checkpoint. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo: null,
        availability: [
          {
            days: null,
            hours: '6:00am - 7:30pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'SP1219',
    name: 'Staples - Acton, MA',
    address1: '145 Great Rd (Route 2A)',
    address2: null,
    zip: '01720',
    city: 'Acton',
    state: 'MA',
    country: 'USA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    importantInfo: null,
    open: false,
    latitude: 42.4828,
    longitude: -71.41508,
    serviceTerritoryId: '0Hhcr0000000iHBCAY',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'SP1219',
        name: null,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo:
          'Memorial Day Hours of Operation: 10:10am - 1:00pm, 1:30pm - 5:00pm',
        availability: [
          {
            days: 'Monday - Friday',
            hours: '9:10am - 1:00pm, 1:30pm - 5:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'ord',
    name: "Chicago O'Hare International Airport - ORD",
    address1: "10000 W O'Hare Ave",
    address2: null,
    zip: '60666',
    city: 'Chicago',
    state: 'IL',
    country: 'USA',
    type: 'airport',
    parking:
      'Parking is located across from the terminal. Hourly and daily parking are available. Onsite and offsite parking are also available.',
    importantInfo: null,
    open: true,
    latitude: 41.9803,
    longitude: -87.909,
    serviceTerritoryId: '0Hhcr0000000bQzCAI',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'ord',
        name: 'Terminal 1',
        description:
          'Located at Terminal 1 nearby the security checkpoint on the Departures Level. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo: null,
        availability: [
          {
            days: null,
            hours: '6:00am - 8:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'WTC',
    name: 'CLEAR World Trade Center - The Oculus',
    address1: '185 Greenwich St',
    address2: 'LL3110',
    zip: '10006',
    city: 'New York',
    state: 'NY',
    country: 'USA',
    type: 'flagship',
    parking: '',
    importantInfo: null,
    open: true,
    latitude: 40.7099,
    longitude: -74.0126,
    serviceTerritoryId: '0Hhcr0000000bZ3CAI',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'WTC',
        name: null,
        description:
          'Located on the main floor of World Trade Center - The Oculus, directly near the subway entrance. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo: null,
        availability: [
          {
            days: 'Monday - Friday',
            hours: '8:00am - 7:00pm',
          },
          {
            days: 'Saturday - Sunday',
            hours: '10:00am - 5:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'SP1319',
    name: 'Staples - Kent, WA',
    address1: '25420 104th Ave SE',
    address2: null,
    zip: '98030',
    city: 'Kent',
    state: 'WA',
    country: 'USA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    importantInfo: null,
    open: false,
    latitude: 47.3737,
    longitude: -122.2008,
    serviceTerritoryId: '0Hhcr0000001JVFCA2',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'SP1319',
        name: null,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo: 'Closed 5/26',
        availability: [
          {
            days: 'Monday - Friday',
            hours: '9:10am - 1:00pm, 1:30pm - 5:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'SP1179',
    name: 'Staples - Temple, TX',
    address1: '2112 SW H.K. Dodgen Loop',
    address2: 'Suite 183',
    zip: '76502',
    city: 'Temple',
    state: 'TX',
    country: 'USA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    importantInfo: null,
    open: false,
    latitude: 31.0786,
    longitude: -97.3784,
    serviceTerritoryId: '0Hhcr0000000fj7CAA',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'SP1179',
        name: null,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo:
          'Memorial Day Hours of Operation: 10:10am - 1:00pm, 1:30pm - 5:00pm',
        availability: [
          {
            days: 'Monday - Friday',
            hours: '9:10am - 1:00pm, 1:30pm - 5:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'SP0117',
    name: 'Staples - La Habra, CA',
    address1: '1310 South Beach Blvd',
    address2: null,
    zip: '90631',
    city: 'La Habra',
    state: 'CA',
    country: 'USA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    importantInfo: null,
    open: false,
    latitude: 33.9169,
    longitude: -117.968,
    serviceTerritoryId: '0Hhcr0000000WUXCA2',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'SP0117',
        name: null,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo: 'Closed 5/26',
        availability: [
          {
            days: 'Monday - Friday',
            hours: '11:00am - 3:00pm, 3:30pm - 7:00pm',
          },
          {
            days: 'Saturday & Sunday',
            hours: 'Closed',
          },
        ],
      },
    ],
  },
  {
    uid: 'SP1903',
    name: 'Staples - Webster, TX',
    address1: '19335 Gulf Freeway',
    address2: null,
    zip: '77598',
    city: 'Webster',
    state: 'TX',
    country: 'USA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    importantInfo: null,
    open: false,
    latitude: 29.54507,
    longitude: -95.1454,
    serviceTerritoryId: '0Hhcr0000000eK1CAI',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'SP1903',
        name: null,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo:
          'Memorial Day Hours of Operation: 10:10am - 1:00pm, 1:30pm - 5:00pm',
        availability: [
          {
            days: 'Monday - Friday',
            hours: '9:10am - 1:00pm, 1:30pm - 5:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'SP1621',
    name: 'Staples - Grandville, MI',
    address1: '3313 Century Center Street SW',
    address2: null,
    zip: '49418',
    city: 'Grandville',
    state: 'MI',
    country: 'USA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    importantInfo: null,
    open: false,
    latitude: 42.8817,
    longitude: -85.7446,
    serviceTerritoryId: '0Hhcr0000000SifCAE',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'SP1621',
        name: null,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo:
          'Memorial Day Hours of Operation: 10:10am - 1:00pm, 1:30pm - 5:00pm, Closed starting 6/24 at 1:30pm through 6/25',
        availability: [
          {
            days: 'Monday - Friday',
            hours: '9:10am - 1:00pm, 1:30pm - 5:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'SP1663',
    name: 'Staples - Milford, CT',
    address1: '1371 Boston Post Rd',
    address2: null,
    zip: '06460',
    city: 'Milford',
    state: 'CT',
    country: 'USA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    importantInfo: null,
    open: false,
    latitude: 41.2399,
    longitude: -73.0342,
    serviceTerritoryId: '0Hhcr0000000U9NCAU',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'SP1663',
        name: null,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo:
          'Memorial Day Hours of Operation: 10:10am - 1:00pm, 1:30pm - 5:00pm',
        availability: [
          {
            days: 'Monday - Friday',
            hours: '9:10am - 1:00pm, 1:30pm - 5:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'SP1702',
    name: 'Staples - Millburn, NJ',
    address1: '2933 Vauxhall Road',
    address2: 'Suite 7',
    zip: '07088',
    city: 'Vauxhall',
    state: 'NJ',
    country: 'USA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    importantInfo: null,
    open: false,
    latitude: 40.7201,
    longitude: -74.2884,
    serviceTerritoryId: '0Hhcr0000000TGXCA2',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'SP1702',
        name: null,
        description:
          'Located in the Travel Services section. Enter through the front vestibule, turn left past the Easy Tech center. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo:
          'Memorial Day Hours of Operation: 10:10am - 1:00pm, 1:30pm - 5:00pm',
        availability: [
          {
            days: 'Monday - Friday',
            hours: '9:10am - 1:00pm, 1:30pm - 5:00pm',
          },
          {
            days: 'Saturday',
            hours: '10:00am - 1:00pm, 1:30pm - 6:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'SP1767',
    name: 'Staples - Willowbrook, IL',
    address1: '7199 S. Kingery Hwy',
    address2: null,
    zip: '60527',
    city: 'Willowbrook',
    state: 'IL',
    country: 'USA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    importantInfo: null,
    open: false,
    latitude: 41.7575,
    longitude: -87.9446,
    serviceTerritoryId: '0Hhcr0000000SltCAE',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'SP1767',
        name: null,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo: 'Closed 5/26',
        availability: [
          {
            days: 'Monday - Friday',
            hours: '9:10am - 1:00pm, 1:30pm - 5:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'SP0094',
    name: 'Staples - Upland, CA',
    address1: '300 S. Mountain Ave',
    address2: null,
    zip: '91786',
    city: 'Upland',
    state: 'CA',
    country: 'USA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    importantInfo: '',
    open: false,
    latitude: 34.0909,
    longitude: -117.67005,
    serviceTerritoryId: '0Hhcr0000000vkfCAA',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'SP0094',
        name: null,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo: 'Closed 5/26',
        availability: [
          {
            days: 'Monday - Friday',
            hours: '11:10am - 3:00pm, 3:30pm - 7:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'san',
    name: 'San Diego International Airport - SAN',
    address1: '3225 N Harbor Dr',
    address2: null,
    zip: '92101',
    city: 'San Diego',
    state: 'CA',
    country: 'USA',
    type: 'airport',
    parking:
      'Parking is located across from the terminal. Hourly and daily parking are available. Onsite and offsite parking are also available.',
    importantInfo: null,
    open: true,
    latitude: 32.73177,
    longitude: -117.197624,
    serviceTerritoryId: '0Hhcr0000000WfpCAE',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'san',
        name: 'Terminal 2',
        description:
          'Located to the left of the entrance on the second floor of Terminal 2. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo: null,
        availability: [
          {
            days: null,
            hours: '5:00am - 5:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'SP0809',
    name: 'Staples - Fishers, IN',
    address1: '8245 East 96th St',
    address2: null,
    zip: '46256',
    city: 'Fishers',
    state: 'IN',
    country: 'USA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    importantInfo: null,
    open: false,
    latitude: 39.9288,
    longitude: -86.0176,
    serviceTerritoryId: '0Hhcr0000000U69CAE',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'SP0809',
        name: null,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo:
          'Memorial Day Hours of Operation: 10:10am - 1:00pm, 1:30pm - 5:00pm',
        availability: [
          {
            days: 'Monday - Friday',
            hours: '9:10am - 1:00pm, 1:30pm - 5:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'SP0186',
    name: 'Staples - Plymouth, MA',
    address1: '131 Samoset Street (Rt 44)',
    address2: null,
    zip: '02360',
    city: 'Plymouth',
    state: 'MA',
    country: 'USA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    importantInfo: null,
    open: false,
    latitude: 41.9601,
    longitude: -70.6702,
    serviceTerritoryId: '0Hhcr0000000g0rCAA',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'SP0186',
        name: null,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo:
          'Memorial Day Hours of Operation: 10:10am - 1:00pm, 1:30pm - 5:00pm',
        availability: [
          {
            days: 'Monday - Friday',
            hours: '9:10am - 1:00pm, 1:30pm - 5:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'mke',
    name: 'Milwaukee Mitchell International Airport - MKE',
    address1: '5300 S Howell Ave',
    address2: null,
    zip: '53207',
    city: 'Milwaukee',
    state: 'WI',
    country: 'USA',
    type: 'airport',
    parking:
      'Parking is located across from the terminal. Hourly and daily parking are available. Onsite and offsite parking are also available.',
    importantInfo: null,
    open: true,
    latitude: 42.94989,
    longitude: -87.900414,
    serviceTerritoryId: '0Hhcr0000000Zx3CAE',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'mke',
        name: 'Main Terminal',
        description:
          'Located on Concourse C and Concourse D nearby the security checkpoint on the Departured level. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo: null,
        availability: [
          {
            days: 'Sunday - Thursday',
            hours: '6:00am - 5:30pm',
          },
          {
            days: 'Friday - Saturday',
            hours: '6:00am - 4:30pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'gsp',
    name: 'Greenville-Spartanburg International Airport - GSP',
    address1: '2000 GSP Dr.',
    address2: null,
    zip: '29651',
    city: 'Greer',
    state: 'SC',
    country: 'USA',
    type: 'airport',
    parking:
      'Parking is located across from the terminal. Hourly and daily parking are available. Onsite and offsite parking are also available.',
    importantInfo: null,
    open: true,
    latitude: 34.8959,
    longitude: -82.2172,
    serviceTerritoryId: '0Hhcr0000000ZqbCAE',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'gsp',
        name: 'Main Terminal',
        description:
          'Located on the second floor across from the security checkpoint entrance. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo: null,
        availability: [
          {
            days: 'Monday, Thursday, Friday, and Sunday',
            hours: '6:00am - 6:00pm',
          },
          {
            days: 'Tuesday, Wednesday, and Saturday',
            hours: '6:00am - 5:30pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'sfo',
    name: 'San Francisco International Airport - SFO',
    address1: 'SFO Airport',
    address2: null,
    zip: '94128',
    city: 'San Francisco',
    state: 'CA',
    country: 'USA',
    type: 'airport',
    parking:
      'Parking is located across from the terminal. Hourly and daily parking are available. Onsite and offsite parking are also available.',
    importantInfo: null,
    open: true,
    latitude: 37.615223,
    longitude: -122.389977,
    serviceTerritoryId: '0Hhcr0000000YphCAE',
    isTestLocation: false,
    lanes: [
      {
        id: '2',
        locationUid: 'sfo',
        name: 'Terminal 3',
        description:
          'Located across from the United Airlines Global check-in on the far right of the checkpoint. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo: null,
        availability: [
          {
            days: null,
            hours: '6:00am - 8:00pm',
          },
        ],
      },
      {
        id: '3',
        locationUid: 'sfo',
        name: 'International Terminal A',
        description:
          'Located in front of the security checkpoint on the Departures level. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: false,
        accessibilityMessage:
          'Accessible pod is available at Terminal 3 - T3F1',
        availability: [
          {
            days: null,
            hours: '7:00am - 8:00pm',
          },
        ],
      },
      {
        id: '1',
        locationUid: 'sfo',
        name: 'Terminal 2',
        description:
          'Located near Door 5 on the Departures level. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: false,
        accessibilityMessage:
          'Accessible pod is available at Terminal 3 - T3F1',
        availability: [
          {
            days: null,
            hours: '6:00am - 8:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'SP0387',
    name: 'Staples - Santa Cruz, CA',
    address1: '2460 17th Avenue Santa',
    address2: null,
    zip: '95062',
    city: 'Cruz',
    state: 'CA',
    country: 'USA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    importantInfo: null,
    open: false,
    latitude: 36.98506,
    longitude: -121.9811,
    serviceTerritoryId: '0Hhcr0000000ho9CAA',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'SP0387',
        name: null,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo: 'Closed 5/26',
        availability: [
          {
            days: 'Thursday - Monday',
            hours: '10:10am - 2:00pm, 2:30pm - 6:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'mci',
    name: 'Kansas City International Airport - MCI',
    address1: '1 City Blvd',
    address2: null,
    zip: '64153',
    city: 'Kansas City',
    state: 'MO',
    country: 'USA',
    type: 'airport',
    parking:
      'Parking is located across from the terminal. Hourly and daily parking are available. Onsite and offsite parking are also available.',
    importantInfo: null,
    open: true,
    latitude: 39.0997,
    longitude: -94.5786,
    serviceTerritoryId: '0Hhcr0000000ZyfCAE',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'mci',
        name: 'Main Terminal',
        description:
          'Located across from the Southwest Airlines ticket counter on the Departures level, near the South escalators. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo: null,
        availability: [
          {
            days: 'Monday - Friday and Sunday',
            hours: '6:00am - 6:00pm',
          },
          {
            days: 'Saturday',
            hours: '6:00am - 5:30pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'okc',
    name: 'Will Rogers World Airport - OKC',
    address1: '7100 Terminal Dr',
    address2: null,
    zip: '73159',
    city: 'Oklahoma City',
    state: 'OK',
    country: 'USA',
    type: 'airport',
    parking:
      'Parking is located across from the terminal. Hourly and daily parking are available. Onsite and offsite parking are also available.',
    importantInfo: null,
    open: true,
    latitude: 35.4676,
    longitude: -97.5164,
    serviceTerritoryId: '0Hhcr0000000aoHCAQ',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'okc',
        name: 'Main Terminal',
        description:
          'Located next to the Delta Air Lines ticketing counter on the Departures level. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo: null,
        availability: [
          {
            days: 'Sunday - Friday',
            hours: '6:00am - 5:00pm',
          },
          {
            days: 'Saturday',
            hours: '6:00am - 4:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'SP1539',
    name: 'Staples - Nashville, TN',
    address1: '100 Powell Place',
    address2: null,
    zip: '37204',
    city: 'Nashville',
    state: 'TN',
    country: 'USA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    importantInfo: null,
    open: false,
    latitude: 36.1056,
    longitude: -86.7656,
    serviceTerritoryId: '0Hhcr0000000eVJCAY',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'SP1539',
        name: null,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo: null,
        availability: [
          {
            days: 'Monday - Tuesday & Thursday - Saturday',
            hours: '9:10am - 1:00pm, 1:30pm - 5:00pm',
          },
          {
            days: 'Wednesday & Sunday',
            hours: 'Closed',
          },
        ],
      },
    ],
  },
  {
    uid: 'bna',
    name: 'Nashville International Airport - BNA',
    address1: '1 Terminal Dr',
    address2: null,
    zip: '37214',
    city: 'Nashville',
    state: 'TN',
    country: 'USA',
    type: 'airport',
    parking:
      'Parking is located across from the terminal. Hourly and daily parking are available. Onsite and offsite parking are also available.',
    importantInfo: null,
    open: true,
    latitude: 36.1245,
    longitude: -86.6781,
    serviceTerritoryId: '0Hhcr0000000at7CAA',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'bna',
        name: 'Main Terminal',
        description:
          'Located on North checkpoint of the security checkpoint entrance, near Delta Air Lines and United Airlines. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo: null,
        availability: [
          {
            days: null,
            hours: '6:00am - 6:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'SP0161',
    name: 'Staples - East Rutherford, NJ',
    address1: '280 State Rt 17',
    address2: null,
    zip: '07073',
    city: 'East Rutherford',
    state: 'NJ',
    country: 'USA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    importantInfo: null,
    open: false,
    latitude: 40.8251,
    longitude: -74.0953,
    serviceTerritoryId: '0Hhcr0000000TZtCAM',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'SP0161',
        name: null,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo: 'Closed 5/26',
        availability: [
          {
            days: 'Monday - Friday',
            hours: '9:10am - 1:00pm, 1:30pm - 5:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'SP1078',
    name: 'Staples - Costa Mesa, CA',
    address1: '241 East 17th St',
    address2: null,
    zip: '92627',
    city: 'Costa Mesa',
    state: 'CA',
    country: 'USA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    importantInfo: null,
    open: false,
    latitude: 33.6339,
    longitude: -117.9176,
    serviceTerritoryId: '0Hhcr0000000Ty5CAE',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'SP1078',
        name: null,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo:
          'Memorial Day Hours of Operation: 10:10am - 1:00pm, 1:30pm - 5:00pm',
        availability: [
          {
            days: 'Monday - Friday',
            hours: '9:10am - 1:00pm, 1:30pm - 5:00pm',
          },
          {
            days: 'Saturday',
            hours: '10:00am - 1:00pm, 1:30pm - 6:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'SP1429',
    name: 'Staples - Conifer, CO',
    address1: '10853 US Highway 285',
    address2: null,
    zip: '80433',
    city: 'Conifer',
    state: 'CO',
    country: 'USA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    importantInfo: null,
    open: false,
    latitude: 39.5186,
    longitude: -105.3061,
    serviceTerritoryId: '0Hhcr0000000TzhCAE',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'SP1429',
        name: null,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo:
          'Memorial Day Hours of Operation: 10:10am - 1:00pm, 1:30pm - 5:00pm',
        availability: [
          {
            days: 'Monday & Friday',
            hours: '9:10am - 1:00pm, 1:30pm - 5:00pm',
          },
          {
            days: 'Tuesday & Thursday',
            hours: '11:00am - 3:00pm, 3:30pm - 7:00pm',
          },
          {
            days: 'Wednesday & Sunday',
            hours: 'Closed',
          },
          {
            days: 'Saturday',
            hours: '10:00am - 1:00pm, 1:30pm - 6:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'boi',
    name: 'Boise Airport - BOI',
    address1: '3201 W Airport Way',
    address2: '#1000',
    zip: '83705',
    city: 'Boise',
    state: 'ID',
    country: 'USA',
    type: 'airport',
    parking:
      'Parking is located across from the terminal. Hourly and daily parking are available. Onsite and offsite parking are also available.',
    importantInfo: null,
    open: true,
    latitude: 43.5609,
    longitude: -116.2174,
    serviceTerritoryId: '0Hhcr0000000Wr7CAE',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'boi',
        name: 'Main Terminal',
        description:
          'Located on the right side of the TSA PreCheck security checkpoint entrance. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo: null,
        availability: [
          {
            days: null,
            hours: '5:00am - 5:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'SP1341',
    name: 'Staples - Manteca, CA',
    address1: '249 Commerce Avenue',
    address2: null,
    zip: '95336',
    city: 'Manteca',
    state: 'CA',
    country: 'USA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    importantInfo: null,
    open: false,
    latitude: 37.7948,
    longitude: -121.1944,
    serviceTerritoryId: '0Hhcr0000001uszCAA',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'SP1341',
        name: null,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo: 'Closed 5/26',
        availability: [
          {
            days: 'Monday - Friday',
            hours: '9:10am - 1:00pm, 1:30pm - 5:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'aus',
    name: 'Austin-Bergstrom International Airport - AUS',
    address1: '3600 Presidential Blvd',
    address2: null,
    zip: '78719',
    city: 'Austin',
    state: 'TX',
    country: 'USA',
    type: 'airport',
    parking:
      'Parking is located across from the terminal. Hourly and daily parking are available. Onsite and offsite parking are also available.',
    importantInfo: null,
    open: true,
    latitude: 30.1953,
    longitude: -97.6667,
    serviceTerritoryId: '0Hhcr0000000bVpCAI',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'aus',
        name: 'Main Terminal',
        description:
          'Located in Checkpoint 1 to the left of the TSA PreCheck line. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo: null,
        availability: [
          {
            days: null,
            hours: '6:00am - 5:30pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'sju',
    name: 'Luis Muñoz Marin International Airport - SJU',
    address1: 'Airport Rd',
    address2: null,
    zip: '00979',
    city: 'Carolina',
    state: 'PR',
    country: 'USA',
    type: 'airport',
    parking:
      'Parking is located across from the terminal. Hourly and daily parking are available. Onsite and offsite parking are also available.',
    importantInfo: null,
    open: true,
    latitude: 18.4378,
    longitude: -66.0042,
    serviceTerritoryId: '0Hhcr0000000bUDCAY',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'sju',
        name: 'Terminal B',
        description:
          'Located on the Departures level near Door #1, next to the elevator. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: false,
        accessibilityMessage:
          'Accessible pod is available at Terminal C, Security Level',
        availability: [
          {
            days: null,
            hours: '6:00am - 8:00pm',
          },
        ],
      },
      {
        id: '2',
        locationUid: 'sju',
        name: 'Terminal C',
        description:
          'Located on the Departures level near Door #2. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo: null,
        availability: [
          {
            days: null,
            hours: '6:00am - 8:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'SP0165',
    name: 'Staples - Long Beach, CA',
    address1: '3515 Atlantic Ave',
    address2: null,
    zip: '90807',
    city: 'Long Beach',
    state: 'CA',
    country: 'USA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    importantInfo: null,
    open: false,
    latitude: 33.8206,
    longitude: -118.1854,
    serviceTerritoryId: '0Hhcr0000000vmHCAQ',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'SP0165',
        name: null,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo: 'Closed 5/26 - 5/30',
        availability: [
          {
            days: 'Monday - Friday',
            hours: '11:10am - 3:00pm, 3:30pm - 7:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'SP0033',
    name: 'Staples - Marlton, NJ',
    address1: '701 W Route 70',
    address2: null,
    zip: '08053',
    city: 'Marlton',
    state: 'NJ',
    country: 'USA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    importantInfo: null,
    open: false,
    latitude: 39.8968,
    longitude: -74.9382,
    serviceTerritoryId: '0Hhcr0000000Td7CAE',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'SP0033',
        name: null,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo:
          'Memorial Day Hours of Operation: 10:10am - 1:00pm, 1:30pm - 5:00pm, Closed 6/23 - 6/27',
        availability: [
          {
            days: 'Monday - Friday',
            hours: '9:10am - 1:00pm, 1:30pm - 5:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'cmh',
    name: 'John Glenn Columbus International Airport - CMH',
    address1: '4600 International Gateway',
    address2: null,
    zip: '43219',
    city: 'Columbus',
    state: 'OH',
    country: 'USA',
    type: 'airport',
    parking:
      'Parking is located across from the terminal. Hourly and daily parking are available. Onsite and offsite parking are also available.',
    importantInfo: null,
    open: true,
    latitude: 39.9999,
    longitude: -82.8872,
    serviceTerritoryId: '0Hhcr0000000a3VCAQ',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'cmh',
        name: 'Terminal B',
        description:
          'Located at Checkpoint B, in the center of the landside terminal. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo: null,
        availability: [
          {
            days: null,
            hours: '6:00am - 7:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'SP1419',
    name: 'Staples - Goodyear, AZ',
    address1: '1755 North Pebblecreek Parkway',
    address2: null,
    zip: '85395',
    city: 'Goodyear',
    state: 'AZ',
    country: 'USA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    importantInfo: '',
    open: false,
    latitude: 33.4664,
    longitude: -112.3878,
    serviceTerritoryId: '0Hhcr0000000fXpCAI',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'SP1419',
        name: null,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo:
          'Memorial Day Hours of Operation: 10:10am - 12:00pm, 12:30pm - 2:00pm',
        availability: [
          {
            days: 'Monday, Wednesday - Friday',
            hours: '9:10am - 12:00pm, 12:30pm - 2:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'SP0425',
    name: 'Staples - Middletown, CT',
    address1: '900 Washington St',
    address2: null,
    zip: '06457',
    city: 'Middletown',
    state: 'CT',
    country: 'USA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    importantInfo: null,
    open: false,
    latitude: 41.5571,
    longitude: -72.6823,
    serviceTerritoryId: '0Hhcr0000000iAjCAI',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'SP0425',
        name: null,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo:
          'Memorial Day Hours of Operation: 10:10am - 1:00pm, 1:30pm - 5:00pm',
        availability: [
          {
            days: 'Monday & Friday',
            hours: '9:10am - 1:00pm, 1:30pm - 5:00pm',
          },
          {
            days: 'Tuesday - Thursday',
            hours: '11:10am - 3:00pm, 3:30pm - 7:00pm',
          },
          {
            days: 'Saturday',
            hours: '10:10am - 2:00pm, 2:30pm - 6:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'SP0059',
    name: 'Staples - Shrewsbury, MA',
    address1: '571 Boston Turnpike',
    address2: null,
    zip: '01545',
    city: 'Shrewsbury',
    state: 'MA',
    country: 'USA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    importantInfo: null,
    open: false,
    latitude: 42.2781,
    longitude: -71.7132,
    serviceTerritoryId: '0Hhcr0000000eqHCAQ',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'SP0059',
        name: null,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo: 'Closed 5/26',
        availability: [
          {
            days: 'Monday - Friday',
            hours: '9:10am - 1:00pm, 1:30pm - 5:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'SP0040',
    name: 'Staples - Hicksville, NY',
    address1: '442 S. Oyster Bay Road',
    address2: null,
    zip: '11801',
    city: 'Hicksville',
    state: 'NY',
    country: 'USA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    importantInfo: '',
    open: false,
    latitude: 40.7805,
    longitude: -73.5033,
    serviceTerritoryId: '0Hhcr0000000SkHCAU',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'SP0040',
        name: null,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo: 'Closed 5/26',
        availability: [
          {
            days: 'Sunday - Monday & Wednesday',
            hours:
              '9:10am - 11:00am, 11:20am - 12:50pm, 1:30pm - 3:00pm, 3:20pm - 4:50pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'SP5308',
    name: 'Staples - New York, NY',
    address1: '800 3rd Ave',
    address2: 'FRNT A',
    zip: '10022',
    city: 'New York',
    state: 'NY',
    country: 'USA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    importantInfo: null,
    open: false,
    latitude: 40.7556,
    longitude: -73.9715,
    serviceTerritoryId: '0Hhcr0000000fWDCAY',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'SP5308',
        name: null,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo: null,
        availability: [
          {
            days: 'Monday  - Friday',
            hours: '10:10am - 2:00pm, 2:30pm - 6:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'SLG',
    name: 'CLEAR Saint Louis Galleria',
    address1: '1155 St Louis Galleria Street',
    address2: null,
    zip: '63117',
    city: 'St. Louis',
    state: 'MO',
    country: 'USA',
    type: 'flagship',
    parking: '',
    importantInfo: null,
    open: false,
    latitude: 38.6363,
    longitude: -90.3469,
    serviceTerritoryId: '0Hhcr0000000cdBCAQ',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'SLG',
        name: null,
        description:
          'Located on the main floor behind the escalator near the Garden Court area. Enter via East entrance near Nordstrom and proceed straight ahead. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo: null,
        availability: [
          {
            days: 'Monday - Saturday',
            hours: '11:00am - 7:00pm',
          },
          {
            days: 'Sunday',
            hours: '12:00pm - 6:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'SP0852',
    name: 'Staples - Sandusky, OH',
    address1: '5500 Milan Road',
    address2: null,
    zip: '44870',
    city: 'Sandusky',
    state: 'OH',
    country: 'USA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    importantInfo: null,
    open: false,
    latitude: 41.4041,
    longitude: -82.65609,
    serviceTerritoryId: '0Hhcr0000000fnxCAA',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'SP0852',
        name: null,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo:
          'Memorial Day Hours of Operation: 10:10am - 1:00pm, 1:30pm - 5:00pm',
        availability: [
          {
            days: 'Monday - Friday',
            hours: '9:10am - 1:00pm, 1:30pm - 5:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'SP0154',
    name: 'Staples - Hyannis, MA',
    address1: '425 Iyannough Rd',
    address2: null,
    zip: '02601',
    city: 'Hyannis',
    state: 'MA',
    country: 'USA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    importantInfo: null,
    open: false,
    latitude: 41.6629,
    longitude: -70.2835,
    serviceTerritoryId: '0Hhcr0000000eYXCAY',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'SP0154',
        name: null,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo:
          'Memorial Day Hours of Operation: 10:10am - 1:00pm, 1:30pm - 5:00pm',
        availability: [
          {
            days: 'Monday - Friday',
            hours: '9:10am - 1:00pm, 1:30pm - 5:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'SP1574',
    name: 'Staples - New York, NY',
    address1: '500 Eighth Avenue',
    address2: 'Front 3',
    zip: '10018',
    city: 'New York',
    state: 'NY',
    country: 'USA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    importantInfo: null,
    open: false,
    latitude: 40.7529,
    longitude: -73.9924,
    serviceTerritoryId: '0Hhcr0000000frBCAQ',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'SP1574',
        name: null,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo: 'Closed 5/26',
        availability: [
          {
            days: 'Monday - Friday',
            hours: '9:10am - 1:00pm, 1:30pm - 5:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'SP0324',
    name: 'Staples - Lansing - East, MI',
    address1: '3003 East Michigan Ave',
    address2: null,
    zip: '48912',
    city: 'Lansing',
    state: 'MI',
    country: 'USA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    importantInfo: null,
    open: false,
    latitude: 42.7341,
    longitude: -84.5093,
    serviceTerritoryId: '0Hhcr0000000WW9CAM',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'SP0324',
        name: null,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo:
          'Memorial Day Hours of Operation: 10:10am - 1:00pm, 1:30pm - 5:00pm',
        availability: [
          {
            days: 'Monday & Friday',
            hours: '9:10am - 1:00pm, 1:30pm - 5:00pm',
          },
          {
            days: 'Tuesday & Thursday',
            hours: '11:00am - 3:00pm, 3:30pm - 7:00pm',
          },
          {
            days: 'Wednesday & Sunday',
            hours: 'Closed',
          },
          {
            days: 'Saturday',
            hours: '10:00am - 1:00pm, 1:30pm - 6:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'SP1555',
    name: 'Staples - North Andover, MA',
    address1: '73 Turnpike St North',
    address2: null,
    zip: '01845',
    city: 'Andover',
    state: 'MA',
    country: 'USA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    importantInfo: null,
    open: false,
    latitude: 42.6772,
    longitude: -71.1323,
    serviceTerritoryId: '0Hhcr0000000gTtCAI',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'SP1555',
        name: null,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo:
          'Memorial Day Hours of Operation: 10:10am - 1:00pm, 1:30pm - 5:00pm',
        availability: [
          {
            days: 'Monday - Friday',
            hours: '9:10am - 1:00pm, 1:30pm - 5:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'SP1581',
    name: 'Staples - Royersford, PA',
    address1: '1844 E. Ridge Pike',
    address2: 'Suite 108',
    zip: '19468',
    city: 'Royersford',
    state: 'PA',
    country: 'USA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    importantInfo: null,
    open: false,
    latitude: 40.2133,
    longitude: -75.4972,
    serviceTerritoryId: '0Hhcr0000000iSTCAY',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'SP1581',
        name: null,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo:
          'Memorial Day Hours of Operation: 10:10am - 1:00pm, 1:30pm - 5:00pm',
        availability: [
          {
            days: 'Monday - Friday',
            hours: '9:10am - 1:00pm, 1:30pm - 5:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'SP1265',
    name: 'Staples - Lakewood, OH',
    address1: '2150 West 117th St',
    address2: null,
    zip: '44111',
    city: 'Lakewood',
    state: 'OH',
    country: 'USA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    importantInfo: null,
    open: false,
    latitude: 41.4762,
    longitude: -81.7688,
    serviceTerritoryId: '0Hhcr0000000hwDCAQ',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'SP1265',
        name: null,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo: 'Closed 5/26',
        availability: [
          {
            days: 'Monday & Thursday - Saturday',
            hours: '10:10am - 2:00pm, 2:30pm - 6:00pm',
          },
          {
            days: 'Sunday',
            hours: '11:10am - 1:30pm, 2:00pm - 5:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'phx',
    name: 'Phoenix Sky Harbor International Airport - PHX',
    address1: '400 Sky Hbr Blvd',
    address2: null,
    zip: '85034',
    city: 'Phoenix',
    state: 'AZ',
    country: 'USA',
    type: 'airport',
    parking:
      'Parking is located across from the terminal. Hourly and daily parking are available. Onsite and offsite parking are also available.',
    importantInfo: null,
    open: true,
    latitude: 33.4354,
    longitude: -112.0079,
    serviceTerritoryId: '0Hhcr0000000dz3CAA',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'phx',
        name: 'Terminal 3, Level 2',
        description:
          'Located on the second floor at the base of the escalators, near the TSA PreCheck screening side. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo: null,
        availability: [
          {
            days: null,
            hours: '6:00am - 7:00pm',
          },
        ],
      },
      {
        id: '2',
        locationUid: 'phx',
        name: 'Terminal 4, Checkpoint B',
        description:
          'Located on the left of the security entrance of Checkpoint B, near the standard screening side. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: false,
        accessibilityMessage:
          'Accessible pod is available at Terminal 3, Level 2.',
        availability: [
          {
            days: 'Monday, Wednesday - Friday',
            hours: '6:00am - 7:00pm',
          },
          {
            days: 'Tuesday and Saturday',
            hours: '6:00am - 6:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'tul',
    name: 'Tulsa International Airport - TUL',
    address1: '7777 Airport Dr',
    address2: null,
    zip: '74115',
    city: 'Tulsa',
    state: 'OK',
    country: 'USA',
    type: 'airport',
    parking:
      'Parking is located across from the terminal. Hourly and daily parking are available. Onsite and offsite parking are also available.',
    importantInfo: null,
    open: true,
    latitude: 36.1874,
    longitude: -95.8931,
    serviceTerritoryId: '0Hhcr0000000b2nCAA',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'tul',
        name: null,
        description:
          'Located across from the Security Checkpoint in Schaub Hall. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo: null,
        availability: [
          {
            days: null,
            hours: '4:00am - 5:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'msy',
    name: 'Louis Armstrong New Orleans International Airport - MSY',
    address1: '900 Airline Dr',
    address2: null,
    zip: '70062',
    city: 'Kenner',
    state: 'LA',
    country: 'USA',
    type: 'airport',
    parking:
      'Parking is located across from the terminal. Hourly and daily parking are available. Onsite and offsite parking are also available.',
    importantInfo: null,
    open: true,
    latitude: 29.9937,
    longitude: -90.2619,
    serviceTerritoryId: '0Hhcr0000000b1BCAQ',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'msy',
        name: 'Main Terminal',
        description:
          'Located on the second floor on the right side of the security checkpoint. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo: null,
        availability: [
          {
            days: null,
            hours: '4:00am - 7:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'jfk',
    name: 'John F. Kennedy International Airport - JFK',
    address1: 'JFK Access Rd',
    address2: null,
    zip: '11430',
    city: 'New York',
    state: 'NY',
    country: 'USA',
    type: 'airport',
    parking:
      'Parking is located across from the terminal. Hourly and daily parking are available. Onsite and offsite parking are also available.',
    importantInfo: null,
    open: true,
    latitude: 40.641766,
    longitude: -73.780968,
    serviceTerritoryId: '0Hhcr0000000ajRCAQ',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'jfk',
        name: 'Terminal 4',
        description:
          'Located to the right of the security checkpoint, near Row #1 at Delta Priority Check-In on the Departures level. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo: null,
        availability: [
          {
            days: null,
            hours: '5:00am - 8:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'SP1715',
    name: 'Staples - Somerville, MA',
    address1: '165 Middlesex Ave',
    address2: null,
    zip: '02145',
    city: 'Somerville',
    state: 'MA',
    country: 'USA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    importantInfo: null,
    open: false,
    latitude: 42.3946,
    longitude: -71.0827,
    serviceTerritoryId: '0Hhcr0000000gSHCAY',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'SP1715',
        name: null,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo:
          'Memorial Day Hours of Operation: 10:10am - 1:00pm, 1:30pm - 5:00pm',
        availability: [
          {
            days: 'Monday - Friday',
            hours: '9:10am - 1:00pm, 1:30pm - 5:00pm',
          },
          {
            days: 'Saturday',
            hours: '10:10am - 2:00pm, 2:30pm - 6:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'bdl',
    name: 'Bradley International Airport - BDL',
    address1: 'Schoephoester Rd',
    address2: null,
    zip: '06096',
    city: 'Windsor Locks',
    state: 'CT',
    country: 'USA',
    type: 'airport',
    parking:
      'Parking is located across from the terminal. Hourly and daily parking are available. Onsite and offsite parking are also available.',
    importantInfo: null,
    open: true,
    latitude: 41.9389,
    longitude: -72.686,
    serviceTerritoryId: '0Hhcr0000000axxCAA',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'bdl',
        name: 'Terminal A',
        description:
          'Located on the Departures level Door 3, across from the security checkpoint entrance. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo: null,
        availability: [
          {
            days: null,
            hours: '4:00am - 6:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'SP1299',
    name: 'Staples - Fremont, CA',
    address1: '39116 Fremont Hub',
    address2: null,
    zip: '94538',
    city: 'Fremont',
    state: 'CA',
    country: 'USA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    importantInfo: null,
    open: false,
    latitude: 37.5465,
    longitude: -121.9873,
    serviceTerritoryId: '0Hhcr0000000g5hCAA',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'SP1299',
        name: null,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo:
          'Memorial Day Hours of Operation: 10:10am - 1:00pm, 1:30pm - 5:00pm',
        availability: [
          {
            days: 'Monday - Friday',
            hours: '9:10am - 1:00pm, 1:30pm - 5:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'slc',
    name: 'Salt Lake City International Airport - SLC',
    address1: '3920 W. Terminal Dr',
    address2: null,
    zip: '84122',
    city: 'Salt Lake City',
    state: 'UT',
    country: 'USA',
    type: 'airport',
    parking:
      'Parking is located across from the terminal. Hourly and daily parking are available. Onsite and offsite parking are also available.',
    importantInfo: null,
    open: true,
    latitude: 40.7863,
    longitude: -111.9733,
    serviceTerritoryId: '0Hhcr0000000bArCAI',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'slc',
        name: 'Main Terminal',
        description:
          'Located on the left side of the main security checkpoint entrance. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo: null,
        availability: [
          {
            days: null,
            hours: '6:00am - 8:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'hou',
    name: 'William P. Hobby Airport - HOU',
    address1: '7800 Airport Blvd',
    address2: null,
    zip: '77061',
    city: 'Houston',
    state: 'TX',
    country: 'USA',
    type: 'airport',
    parking:
      'Parking is located across from the terminal. Hourly and daily parking are available. Onsite and offsite parking are also available.',
    importantInfo: null,
    open: true,
    latitude: 29.6459,
    longitude: -95.2769,
    serviceTerritoryId: '0Hhcr0000000ZvRCAU',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'hou',
        name: 'Main Terminal',
        description:
          'Located in front of the main security checkpoint entrance. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo: null,
        availability: [
          {
            days: 'Sunday - Monday, Wednesday - Friday',
            hours: '6:00am - 8:00pm',
          },
          {
            days: 'Tuesday',
            hours: '6:00am - 7:00pm',
          },
          {
            days: 'Saturday',
            hours: '6:00am - 5:30pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'SP0627',
    name: 'Staples - Doylestown, PA',
    address1: '436 N. Main St.',
    address2: null,
    zip: '18901',
    city: 'Doylestown',
    state: 'PA',
    country: 'USA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    importantInfo: null,
    open: false,
    latitude: 40.32004,
    longitude: -75.1308,
    serviceTerritoryId: '0Hhcr0000000XVRCA2',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'SP0627',
        name: null,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo:
          'Memorial Day Hours of Operation: 10:10am - 1:00pm, 1:30pm - 5:00pm',
        availability: [
          {
            days: 'Monday - Friday',
            hours: '9:10am - 1:00pm, 1:30pm - 5:00pm',
          },
          {
            days: 'Saturday',
            hours: '10:00am - 1:00pm, 1:30pm - 6:00pm',
          },
          {
            days: 'Sunday',
            hours: 'Closed',
          },
        ],
      },
    ],
  },
  {
    uid: 'SP1634',
    name: 'Staples - Rolling Meadows, IL',
    address1: '1551 Algonquin Rd',
    address2: null,
    zip: '60008',
    city: 'Rolling Meadows',
    state: 'IL',
    country: 'USA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    importantInfo: null,
    open: false,
    latitude: 42.0305,
    longitude: -87.94903,
    serviceTerritoryId: '0Hhcr0000000edNCAQ',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'SP1634',
        name: null,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo:
          'Memorial Day Hours of Operation: 10:10am - 1:00pm, 1:30pm - 5:00pm',
        availability: [
          {
            days: 'Monday - Friday',
            hours: '9:10am - 1:00pm, 1:30pm - 5:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'GRR',
    name: 'Gerald R. Ford International Airport - GRR',
    address1: '5500 44th Street SE',
    address2: null,
    zip: '49512',
    city: 'Grand Rapids',
    state: 'MI',
    country: 'USA',
    type: 'airport',
    parking:
      'Parking is located across from the terminal. Hourly and daily parking are available. Onsite and offsite parking are also available.',
    importantInfo: null,
    open: true,
    latitude: 42.8853,
    longitude: -85.5303,
    serviceTerritoryId: '0Hhcr0000000al3CAA',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'GRR',
        name: 'Main Terminal',
        description:
          'Located on Level 1 near the baggage claim area. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo: null,
        availability: [
          {
            days: 'Monday - Sunday',
            hours: '7:00am - 3:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'smf',
    name: 'Sacramento International Airport - SMF',
    address1: '6900 Airport Blvd',
    address2: null,
    zip: '95837',
    city: 'Sacramento',
    state: 'CA',
    country: 'USA',
    type: 'airport',
    parking:
      'Parking is located across from the terminal. Hourly and daily parking are available. Onsite and offsite parking are also available.',
    importantInfo: null,
    open: true,
    latitude: 38.6955,
    longitude: -121.59083,
    serviceTerritoryId: '0Hhcr0000000bSbCAI',
    isTestLocation: false,
    lanes: [
      {
        id: '2',
        locationUid: 'smf',
        name: 'Terminal B',
        description:
          'Located on the right side of the AirTrain entrance. Look for TSA PreCheck® and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo: null,
        availability: [
          {
            days: 'Sunday - Friday',
            hours: '6:00am - 8:00pm',
          },
          {
            days: 'Saturday',
            hours: '6:00am - 6:00pm',
          },
        ],
      },
      {
        id: '1',
        locationUid: 'smf',
        name: 'Terminal A',
        description:
          'Located in front of the security checkpoint entrance on Level 2. Look for TSA PreCheck® and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo: null,
        availability: [
          {
            days: 'Sunday - Friday',
            hours: '12:00pm - 8:00pm',
          },
          {
            days: 'Saturday',
            hours: '12:00pm - 6:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'sea',
    name: 'Seattle-Tacoma International Airport - SEA',
    address1: '17801 International Blvd',
    address2: null,
    zip: '98158',
    city: 'SeaTac',
    state: 'WA',
    country: 'USA',
    type: 'airport',
    parking:
      'Parking is located across from the terminal. Hourly and daily parking are available. Onsite and offsite parking are also available.',
    importantInfo: null,
    open: true,
    latitude: 47.443546,
    longitude: -122.301659,
    serviceTerritoryId: '0Hhcr0000000bE5CAI',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'sea',
        name: 'Main Terminal',
        description:
          'Located at Checkpoint 3 near the Delta Air Lines ticket counter. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo: null,
        availability: [
          {
            days: null,
            hours: '6:00am - 8:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'SP1657',
    name: 'Staples - Oak Lawn, IL',
    address1: '9631 S. Cicero Ave',
    address2: null,
    zip: '60453',
    city: 'Oak Lawn',
    state: 'IL',
    country: 'USA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    importantInfo: null,
    open: false,
    latitude: 41.7175,
    longitude: -87.7393,
    serviceTerritoryId: '0Hhcr0000000iVhCAI',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'SP1657',
        name: null,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo: 'Closed 5/26',
        availability: [
          {
            days: 'Thursday - Monday',
            hours: '10:10am - 2:00pm, 2:30pm - 6:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'cle',
    name: 'Cleveland Hopkins International Airport - CLE',
    address1: '5300 Riverside Dr',
    address2: null,
    zip: '44135',
    city: 'Cleveland',
    state: 'OH',
    country: 'USA',
    type: 'airport',
    parking:
      'Parking is located across from the terminal. Hourly and daily parking are available. Onsite and offsite parking are also available.',
    importantInfo: null,
    open: true,
    latitude: 41.4993,
    longitude: -81.6944,
    serviceTerritoryId: '0Hhcr0000000aQ5CAI',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'cle',
        name: 'Main Terminal',
        description:
          'Located on the Departures level between Door 3 and 4. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo: null,
        availability: [
          {
            days: 'Monday - Friday and Sunday',
            hours: '6:00am - 8:00pm',
          },
          {
            days: 'Saturday',
            hours: '6:00am - 7:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'SP0426',
    name: 'Staples - Norwood, MA',
    address1: '991 Providence Hwy',
    address2: null,
    zip: '02062',
    city: 'Norwood',
    state: 'MA',
    country: 'USA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    importantInfo: null,
    open: false,
    latitude: 42.1778,
    longitude: -71.1923,
    serviceTerritoryId: '0Hhcr0000000fZRCAY',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'SP0426',
        name: null,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo: 'Closed 5/26',
        availability: [
          {
            days: 'Monday, Wednesday, & Thursday',
            hours: '9:10am - 12:00pm, 12:30pm - 2:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'PDX',
    name: 'Portland International Airport - PDX',
    address1: '7000 NE Airport Way',
    address2: null,
    zip: '97218',
    city: 'Portland',
    state: 'OR',
    country: 'USA',
    type: 'airport',
    parking:
      'Parking is located across from the terminal. Hourly and daily parking are available. Onsite and offsite parking are also available.',
    importantInfo: null,
    open: true,
    latitude: 45.5889,
    longitude: -122.59304,
    serviceTerritoryId: '0Hhcr0000000bqnCAA',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'PDX',
        name: 'Main Terminal',
        description:
          'Located on the ticketing level on the North side of the Garden. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo: null,
        availability: [
          {
            days: 'Monday - Sunday',
            hours: '7:00am - 5:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'SP0913',
    name: 'Staples - Medina, OH',
    address1: '4029 Pearl Rd',
    address2: null,
    zip: '44256',
    city: 'Medina',
    state: 'OH',
    country: 'USA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    importantInfo: null,
    open: false,
    latitude: 41.1649,
    longitude: -81.8619,
    serviceTerritoryId: '0Hhcr0000000fb3CAA',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'SP0913',
        name: null,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo:
          'Memorial Day Hours of Operation: 10:10am - 1:00pm, 1:30pm - 5:00pm',
        availability: [
          {
            days: 'Monday - Friday',
            hours: '9:10am - 1:00pm, 1:30pm - 5:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'SP0882',
    name: 'Staples - Tarpon Springs, FL',
    address1: '41334 North Hwy 19 N',
    address2: null,
    zip: '34689',
    city: 'Tarpon Springs',
    state: 'FL',
    country: 'USA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    importantInfo: null,
    open: false,
    latitude: 28.1471,
    longitude: -82.7432,
    serviceTerritoryId: '0Hhcr0000000fhVCAQ',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'SP0882',
        name: null,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo: 'Closed 5/26',
        availability: [
          {
            days: 'Monday - Friday',
            hours: '9:10am - 1:00pm, 1:30pm - 5:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'PLA',
    name: 'CLEAR Plaza Las Americas',
    address1: '525 Avenida F.D. Roosevelt',
    address2: null,
    zip: '00918',
    city: 'San Juan, Puerto Rico',
    state: null,
    country: 'USA',
    type: 'flagship',
    parking: 'Parking is available at the mall.',
    importantInfo: null,
    open: false,
    latitude: 18.4188,
    longitude: -66.0733,
    serviceTerritoryId: '0Hhcr0000000c0TCAQ',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'PLA',
        name: null,
        description:
          'Located on level 1 of Plaza Las Americas, across from the Lacoste store. Enter via the entrance near the Genesis store, proceed straight ahead, and take a right before the escalator. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo: null,
        availability: [
          {
            days: 'Monday - Saturday',
            hours: '11:00am - 7:00pm',
          },
          {
            days: 'Sunday',
            hours: '12:00pm - 7:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'SP1257',
    name: 'Staples - Brooklyn - Gateway Ctr, NY',
    address1: '409 Gateway Drive',
    address2: null,
    zip: '11239',
    city: 'Brooklyn',
    state: 'NY',
    country: 'USA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    importantInfo: null,
    open: false,
    latitude: 40.6521,
    longitude: -73.8715,
    serviceTerritoryId: '0Hhcr0000000TbVCAU',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'SP1257',
        name: null,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo:
          'Memorial Day Hours of Operation: 10:10am - 1:00pm, 1:30pm - 5:00pm',
        availability: [
          {
            days: 'Monday - Friday',
            hours: '9:10am - 1:00pm, 1:30pm - 5:00pm',
          },
          {
            days: 'Saturday',
            hours: '10:00am - 1:00pm, 1:30pm - 6:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'SP0616',
    name: 'Staples - Pasadena, CA',
    address1: '3660 Colorado Blvd',
    address2: null,
    zip: '91107',
    city: 'Pasadena',
    state: 'CA',
    country: 'USA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    importantInfo: '',
    open: false,
    latitude: 34.1456,
    longitude: -118.0745,
    serviceTerritoryId: '0Hhcr0000001JILCA2',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'SP0616',
        name: null,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo: 'Closed 5/26 & 5/29 - 6/2',
        availability: [
          {
            days: 'Monday - Friday',
            hours: '9:10am - 1:00pm, 1:30pm - 5:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'SP0360',
    name: 'Staples - Clawson, MI',
    address1: '1129 West 14 Mile Rd',
    address2: null,
    zip: '48017',
    city: 'Clawson',
    state: 'MI',
    country: 'USA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    importantInfo: null,
    open: false,
    latitude: 42.5319,
    longitude: -83.1619,
    serviceTerritoryId: '0Hhcr0000000hUnCAI',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'SP0360',
        name: null,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo: 'Closed 5/26',
        availability: [
          {
            days: 'Thursday - Monday',
            hours: '10:10 am - 2:00pm, 2:30pm - 6:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'TWM',
    name: 'CLEAR The Woodlands',
    address1: '1201 Lake Woodlands Dr',
    address2: 'Suite 700',
    zip: '77380',
    city: 'The Woodlands',
    state: 'TX',
    country: 'USA',
    type: 'flagship',
    parking: 'Parking is available at the mall.',
    importantInfo: null,
    open: true,
    latitude: 30.1646,
    longitude: -95.4537,
    serviceTerritoryId: '0Hhcr0000000cZxCAI',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'TWM',
        name: null,
        description:
          "Located on the main floor of The Woodlands Mall. Enter via the west entrance near Macy's and head straight down the walkway. Look for TSA PreCheck and CLEAR signage.",
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo: null,
        availability: [
          {
            days: 'Monday - Saturday',
            hours: '11:00am - 7:00pm',
          },
          {
            days: 'Sunday',
            hours: '12:00pm - 6:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'SP1615',
    name: 'Staples - Shorewood, IL',
    address1: '992 Brook Forest Avenue',
    address2: null,
    zip: '60404',
    city: 'Shorewood',
    state: 'IL',
    country: 'USA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    importantInfo: '',
    open: false,
    latitude: 41.53909,
    longitude: -88.1992,
    serviceTerritoryId: '0Hhcr0000000fcfCAA',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'SP1615',
        name: null,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo: 'Closed 5/26',
        availability: [
          {
            days: 'Monday - Friday',
            hours: '9:10am - 1:00pm, 1:30pm - 5:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'dtw',
    name: 'Detroit Metropolitan Wayne County Airport - DTW',
    address1: '1 Detroit Metro Airport',
    address2: null,
    zip: '48242',
    city: 'Romulus',
    state: 'MI',
    country: 'USA',
    type: 'airport',
    parking:
      'Parking is located across from the terminal. Hourly and daily parking are available. Onsite and offsite parking are also available.',
    importantInfo: null,
    open: true,
    latitude: 42.2132,
    longitude: -83.3525,
    serviceTerritoryId: '0Hhcr0000000WeDCAU',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'dtw',
        name: 'McNamara Terminal, Red 1',
        description:
          'Located near Door 4 on the Departures level of the McNamara security checkpoint. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo: null,
        availability: [
          {
            days: null,
            hours: '6:00am - 8:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'SRQ',
    name: 'Sarasota Bradenton International Airport - SRQ',
    address1: '6000 Airport Cir',
    address2: null,
    zip: '34243',
    city: 'Sarasota',
    state: 'FL',
    country: 'USA',
    type: 'airport',
    parking:
      'Parking is located across from the terminal. Hourly and daily parking are available. Onsite and offsite parking are also available.',
    importantInfo: null,
    open: false,
    latitude: 27.3875,
    longitude: -82.5534,
    serviceTerritoryId: '0Hhcr0000000hplCAA',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'SRQ',
        name: 'Terminal B, Level 2',
        description:
          'Located on Level 2 near the entrance to the arrivals area. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo: null,
        availability: [
          {
            days: 'Monday',
            hours: '10:00am - 6:00pm',
          },
          {
            days: 'Tuesday - Sunday',
            hours: '6:00am - 6:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'lgb',
    name: 'Long Beach Airport - LGB',
    address1: '4100 Donald Douglas Dr',
    address2: null,
    zip: '90808',
    city: 'Long Beach',
    state: 'CA',
    country: 'USA',
    type: 'airport',
    parking:
      'Parking is located across from the terminal. Hourly and daily parking are available. Onsite and offsite parking are also available.',
    importantInfo: null,
    open: true,
    latitude: 33.8161,
    longitude: -118.1513,
    serviceTerritoryId: '0Hhcr0000000WvxCAE',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'lgb',
        name: 'Main Terminal',
        description:
          'Located inside the Main Terminal on the TSA PreCheck screening side. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo: null,
        availability: [
          {
            days: 'Thursday - Friday and Sunday',
            hours: '6:00am - 6:00pm',
          },
          {
            days: 'Monday - Wednesday and Saturday',
            hours: '6:00am - 5:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'SP0063',
    name: 'Staples - Boston, MA',
    address1: '1 Washington Street',
    address2: null,
    zip: '02108',
    city: 'Boston',
    state: 'MA',
    country: 'USA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    importantInfo: null,
    open: false,
    latitude: 42.3592,
    longitude: -71.0579,
    serviceTerritoryId: '0Hhcr0000000fw1CAA',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'SP0063',
        name: null,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo: 'Closed 5/26',
        availability: [
          {
            days: 'Monday - Friday',
            hours: '9:10am - 1:00pm, 1:30pm - 5:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'iah',
    name: 'George Bush Intercontinental Airport - IAH',
    address1: '2800 N Terminal Rd',
    address2: null,
    zip: '77032',
    city: 'Houston',
    state: 'TX',
    country: 'USA',
    type: 'airport',
    parking:
      'Parking is located across from the terminal. Hourly and daily parking are available. Onsite and offsite parking are also available.',
    importantInfo: null,
    open: true,
    latitude: 29.9931,
    longitude: -95.3416,
    serviceTerritoryId: '0Hhcr0000000b9FCAQ',
    isTestLocation: false,
    lanes: [
      {
        id: '3',
        locationUid: 'iah',
        name: 'Terminal C - Post Security',
        description:
          'Located near the entrance to the Skyway. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: false,
        accessibilityMessage:
          'Accessible pod is available at Terminal A - South',
        availability: [
          {
            days: null,
            hours: '7:00am - 7:00pm',
          },
        ],
      },
      {
        id: '1',
        locationUid: 'iah',
        name: 'Terminal A',
        description:
          'Located on Level 2 Departures between Southwest and Delta Air Lines check-in counters. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: false,
        accessibilityMessage:
          'Accessible pod is available at Terminal A - South',
        availability: [
          {
            days: null,
            hours: '4:00am - 6:00pm',
          },
        ],
      },
      {
        id: '2',
        locationUid: 'iah',
        name: 'Terminal C',
        description:
          'Located on Level 2 at the United Airlines checkpoint. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: false,
        accessibilityMessage:
          'Accessible pod is available at Terminal A - South',
        availability: [
          {
            days: null,
            hours: '6:00am - 7:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'den',
    name: 'Denver International Airport - DEN',
    address1: '8500 Pena Blvd',
    address2: null,
    zip: '80249',
    city: 'Denver',
    state: 'CO',
    country: 'USA',
    type: 'airport',
    parking:
      'Parking is located across from the terminal. Hourly and daily parking are available. Onsite and offsite parking are also available.',
    importantInfo: null,
    open: true,
    latitude: 39.849312,
    longitude: -104.673828,
    serviceTerritoryId: '0Hhcr0000000bCTCAY',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'den',
        name: 'Main Terminal, South',
        description:
          'Located on the southwest corner of the security checkpoint, under the escalator. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo: null,
        availability: [
          {
            days: null,
            hours: '6:00am - 8:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'SGM',
    name: 'CLEAR Sawgrass Mills',
    address1: '12801 W Sunrise Blvd',
    address2: null,
    zip: '33323',
    city: 'Sunrise',
    state: 'FL',
    country: 'USA',
    type: 'flagship',
    parking: 'Parking is available at the mall.',
    importantInfo: null,
    open: false,
    latitude: 26.1514,
    longitude: -80.32104,
    serviceTerritoryId: '0Hhcr0000000c5JCAQ',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'SGM',
        name: null,
        description:
          'Located on the main floor between the Perry Ellis and Burlington Coat Factory stores. Enter via the Oasis entrance and proceed straight ahead. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo: null,
        availability: [
          {
            days: 'Monday - Sunday',
            hours: '11:00am - 3:00pm, 3:30pm - 7:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'SP1353',
    name: 'Staples - Petaluma, CA',
    address1: '207 South McDowell Blvd',
    address2: null,
    zip: '94954',
    city: 'Petaluma',
    state: 'CA',
    country: 'USA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    importantInfo: null,
    open: false,
    latitude: 38.25,
    longitude: -122.6248,
    serviceTerritoryId: '0Hhcr0000000U2vCAE',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'SP1353',
        name: null,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo:
          'Memorial Day Hours of Operation: 10:10am - 1:00pm, 1:30pm - 5:00pm',
        availability: [
          {
            days: 'Monday - Friday',
            hours: '9:10am - 1:00pm, 1:30pm - 5:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'mco',
    name: 'Orlando International Airport - MCO',
    address1: '1 Jeff Fuqua Blvd',
    address2: null,
    zip: '32827',
    city: 'Orlando',
    state: 'FL',
    country: 'USA',
    type: 'airport',
    parking:
      'Parking is located across from the terminal. Hourly and daily parking are available. Onsite and offsite parking are also available.',
    importantInfo: null,
    open: true,
    latitude: 28.431157699999993,
    longitude: -81.30808300000001,
    serviceTerritoryId: '0Hhcr0000000amfCAA',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'mco',
        name: 'Terminals A & B',
        description:
          'Located on the B side (west side) of the security checkpoint entrance for Gates 1-59, next to the United Airlines ticket counter. Look for TSA PreCheck® and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo: null,
        availability: [
          {
            days: null,
            hours: '4:00am - 8:00pm',
          },
        ],
      },
      {
        id: '2',
        locationUid: 'mco',
        name: 'Terminal C',
        description:
          'Located in front of the security checkpoint entrance for Gates 230-249. Look for TSA PreCheck® and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo: null,
        availability: [
          {
            days: null,
            hours: '6:00am - 8:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'SP0614',
    name: 'Staples - New Kensington, PA',
    address1: '100 Tarentum Bridge Rd',
    address2: 'STE 7',
    zip: '15068',
    city: 'New Kensington',
    state: 'PA',
    country: 'USA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    importantInfo: null,
    open: false,
    latitude: 40.5864,
    longitude: -79.7491,
    serviceTerritoryId: '0Hhcr0000000iNdCAI',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'SP0614',
        name: null,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo:
          'Memorial Day Hours of Operation: 10:10am - 1:00pm, 1:30pm - 5:00pm',
        availability: [
          {
            days: 'Monday - Friday',
            hours: '9:10am - 1:00pm, 1:30pm - 5:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'dfw',
    name: 'Dallas/Fort Worth International Airport - DFW',
    address1: '2400 Aviation Dr',
    address2: null,
    zip: '75261',
    city: 'Dallas',
    state: 'TX',
    country: 'USA',
    type: 'airport',
    parking:
      'Parking is located across from the terminal. Hourly and daily parking are available. Onsite and offsite parking are also available.',
    importantInfo: null,
    open: true,
    latitude: 32.8448,
    longitude: -96.8495,
    serviceTerritoryId: '',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'dfw',
        name: 'Terminal E',
        description:
          'Located on Level 1 through Door E20 in Terminal E. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: false,
        accessibilityMessage:
          'Accessible pod is available at Terminal E - E16 Checkpoint location.',
        availability: [
          {
            days: null,
            hours: '6:00am - 6:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'SP0454',
    name: 'Staples - Bowie, MD',
    address1: '4450 Mitchellville Road',
    address2: null,
    zip: '20716',
    city: 'Bowie',
    state: 'MD',
    country: 'USA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    importantInfo: null,
    open: false,
    latitude: 38.9506,
    longitude: -76.7215,
    serviceTerritoryId: '0Hhcr0000000XYfCAM',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'SP0454',
        name: null,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo: 'Closed 5/26',
        availability: [
          {
            days: 'Monday, Wednesday, & Friday',
            hours: '9:10am - 1:00pm, 1:30pm - 5:00pm',
          },
          {
            days: 'Tuesday & Thursday',
            hours: '11:00am - 3:00pm, 3:30pm - 7:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'msp',
    name: 'Minneapolis-Saint Paul International Airport - MSP',
    address1: '4300 Glumack Dr St',
    address2: null,
    zip: '55111',
    city: 'Paul',
    state: 'MN',
    country: 'USA',
    type: 'airport',
    parking:
      'Parking is located across from the terminal. Hourly and daily parking are available. Onsite and offsite parking are also available.',
    importantInfo: null,
    open: true,
    latitude: 44.8851,
    longitude: -93.2144,
    serviceTerritoryId: '0Hhcr0000000aRhCAI',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'msp',
        name: 'Terminal 1',
        description:
          'Located on the left hand side of Door 1, across from the American Airlines ticketing counter. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo: null,
        availability: [
          {
            days: null,
            hours: '6:00am - 8:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'SP1379',
    name: 'Staples - Menlo Park, CA',
    address1: '700 El Camino Real',
    address2: 'Suite 120',
    zip: '94025',
    city: 'Menlo Park',
    state: 'CA',
    country: 'USA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    importantInfo: null,
    open: false,
    latitude: 37.4517,
    longitude: -122.1785,
    serviceTerritoryId: '0Hhcr0000000iU5CAI',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'SP1379',
        name: null,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo:
          'Memorial Day Hours of Operation: 10:10am - 1:00pm, 1:30pm - 5:00pm',
        availability: [
          {
            days: 'Monday - Friday',
            hours: '9:10am - 1:00pm, 1:30pm - 5:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'SP0135',
    name: 'Staples - Palm Desert, CA',
    address1: '72-811 Highway 111',
    address2: null,
    zip: '92260',
    city: 'Palm Desert',
    state: 'CA',
    country: 'USA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    importantInfo: null,
    open: false,
    latitude: 33.7299,
    longitude: -116.4039,
    serviceTerritoryId: '0Hhcr0000000fftCAA',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'SP0135',
        name: null,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo: 'Closed 5/26',
        availability: [
          {
            days: 'Monday - Friday',
            hours: '9:10am - 1:00pm, 1:30pm - 5:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'lga',
    name: 'LaGuardia Airport - LGA',
    address1: '9400 Ditmars Blvd',
    address2: null,
    zip: '11369',
    city: 'East Elmhurst',
    state: 'NY',
    country: 'USA',
    type: 'airport',
    parking:
      'Parking is located across from the terminal. Hourly and daily parking are available. Onsite and offsite parking are also available.',
    importantInfo: null,
    open: true,
    latitude: 40.776863,
    longitude: -73.874069,
    serviceTerritoryId: '0Hhcr0000000bNlCAI',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'lga',
        name: 'Terminal C',
        description:
          'Located in front of the security checkpoint entrance on Level 3. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo: null,
        availability: [
          {
            days: 'Sunday - Friday',
            hours: '6:00am - 8:00pm',
          },
          {
            days: 'Saturday',
            hours: '5:00am - 6:00pm',
          },
        ],
      },
      {
        id: '3',
        locationUid: 'lga',
        name: 'Terminal C, Post-Security Checkpoint',
        description:
          'Located right after the security checkpoint on the standard screening side. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo: null,
        availability: [
          {
            days: 'Sunday - Friday',
            hours: '6:00am - 8:00pm',
          },
          {
            days: 'Saturday',
            hours: '6:00am - 6:00pm',
          },
        ],
      },
      {
        id: '2',
        locationUid: 'lga',
        name: 'Terminal B',
        description:
          'Located on Level 2 - Arrivals, between Baggage Claim 4 and 5 near the elevators. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo: null,
        availability: [
          {
            days: 'Sunday - Friday',
            hours: '6:00am - 8:00pm',
          },
          {
            days: 'Saturday',
            hours: '6:00am - 6:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'SP0674',
    name: 'Staples - Citrus Heights, CA',
    address1: '6330 Sunrise Blvd',
    address2: null,
    zip: '95610',
    city: 'Citrus Heights',
    state: 'CA',
    country: 'USA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    importantInfo: '',
    open: false,
    latitude: 38.6818,
    longitude: -121.2708,
    serviceTerritoryId: '0Hhcr0000000dCfCAI',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'SP0674',
        name: null,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo:
          'Memorial Day Hours of Operation: 10:10am - 10:20am, 10:40am - 12:00pm, 12:40pm - 5:00pm, Closed 6/9',
        availability: [
          {
            days: 'Monday - Wednesday',
            hours: '9:10am - 10:20am, 10:40am - 12:00pm, 12:40pm - 3:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'SP0085',
    name: 'Staples - Pikesville, MD',
    address1: '1340 Reisterstown Rd',
    address2: '#1354',
    zip: '21208',
    city: 'Pikesville',
    state: 'MD',
    country: 'USA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    importantInfo: null,
    open: false,
    latitude: 39.3761,
    longitude: -76.7246,
    serviceTerritoryId: '0Hhcr0000000eWvCAI',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'SP0085',
        name: null,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo:
          'Memorial Day Hours of Operation: 10:10am - 1:00pm, 1:30pm - 5:00pm',
        availability: [
          {
            days: 'Monday - Friday',
            hours: '9:10am - 1:00pm, 1:30pm - 5:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'pbi',
    name: 'Palm Beach International Airport - PBI',
    address1: '1000 James L. Turnage Blvd',
    address2: null,
    zip: '33415',
    city: 'West Palm Beach',
    state: 'FL',
    country: 'USA',
    type: 'airport',
    parking:
      'Parking is located across from the terminal. Hourly and daily parking are available. Onsite and offsite parking are also available.',
    importantInfo: null,
    open: true,
    latitude: 26.6857,
    longitude: -80.0928,
    serviceTerritoryId: '0Hhcr0000000bFhCAI',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'pbi',
        name: 'Terminal C, Security Level',
        description:
          'Located in Terminal C on the second level across from the security checkpoint entrance. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo: null,
        availability: [
          {
            days: null,
            hours: '6:00am - 7:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'rdu',
    name: 'Raleigh-Durham International Airport - RDU',
    address1: '2400 John Brantley Blvd',
    address2: null,
    zip: '27560',
    city: 'Morrisville',
    state: 'NC',
    country: 'USA',
    type: 'airport',
    parking:
      'Parking is located across from the terminal. Hourly and daily parking are available. Onsite and offsite parking are also available.',
    importantInfo: null,
    open: true,
    latitude: 35.8801,
    longitude: -78.788,
    serviceTerritoryId: '0Hhcr0000000WmHCAU',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'rdu',
        name: 'Terminal 2',
        description:
          'Located across from the Delta Air Lines ticketing counter. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo: null,
        availability: [
          {
            days: null,
            hours: '6:00am - 6:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'bhm',
    name: 'Birmingham-Shuttlesworth International Airport - BHM',
    address1: '5900 Messer Airport Hwy',
    address2: null,
    zip: '35212',
    city: 'Birmingham',
    state: 'AL',
    country: 'USA',
    type: 'airport',
    parking:
      'Parking is located across from the terminal. Hourly and daily parking are available. Onsite and offsite parking are also available.',
    importantInfo: null,
    open: true,
    latitude: 33.5625,
    longitude: -86.7542,
    serviceTerritoryId: '0Hhcr0000000WpVCAU',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'bhm',
        name: 'Main Terminal',
        description:
          'Located in front of the security checkpoint on the Departure level. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo: null,
        availability: [
          {
            days: 'Sunday - Friday',
            hours: '7:00am - 6:00pm',
          },
          {
            days: 'Saturday',
            hours: '6:00am - 4:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'sjc',
    name: 'Norman Y. Miñeta San Jose International Airport - SJC',
    address1: '1701 Airport Blvd',
    address2: null,
    zip: '95110',
    city: 'San Jose',
    state: 'CA',
    country: 'USA',
    type: 'airport',
    parking:
      'Parking is located across from the terminal. Hourly and daily parking are available. Onsite and offsite parking are also available.',
    importantInfo: null,
    open: true,
    latitude: 37.363949,
    longitude: -121.92894,
    serviceTerritoryId: '0Hhcr0000000WxZCAU',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'sjc',
        name: 'Terminal B',
        description:
          'Located on the Departures level, on the left side of the standard security entrance. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo: null,
        availability: [
          {
            days: 'Sunday - Friday',
            hours: '6:00am - 8:00pm',
          },
          {
            days: 'Saturday',
            hours: '6:00am - 6:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'SP0459',
    name: 'Staples - Tualatin, OR',
    address1: '8795 SW Tualatin Sherwood Rd',
    address2: null,
    zip: '97062',
    city: 'Tualatin',
    state: 'OR',
    country: 'USA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    importantInfo: null,
    open: false,
    latitude: 45.3821,
    longitude: -122.7678,
    serviceTerritoryId: '0Hhcr0000000ea9CAA',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'SP0459',
        name: null,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo: 'Closed 5/26',
        availability: [
          {
            days: 'Wednesday - Friday',
            hours: '9:10am - 1:00pm, 1:30pm - 5:00pm',
          },
          {
            days: 'Monday & Tuesday',
            hours: 'Closed',
          },
        ],
      },
    ],
  },
  {
    uid: 'SP1085',
    name: 'Staples - Allen, TX',
    address1: '812 West McDermott Dr',
    address2: null,
    zip: '75013',
    city: 'Allen',
    state: 'TX',
    country: 'USA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    importantInfo: null,
    open: false,
    latitude: 33.1038,
    longitude: -96.6812,
    serviceTerritoryId: '0Hhcr0000000g45CAA',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'SP1085',
        name: null,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo: 'Closed 5/26',
        availability: [
          {
            days: 'Monday - Friday',
            hours: '9:10am - 1:00pm, 1:30pm - 5:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'SP1446',
    name: 'Staples - Westminster - Broomfield, CO',
    address1: '5150 W 120th Ave',
    address2: 'Suite 100',
    zip: '80020',
    city: 'Westminster',
    state: 'CO',
    country: 'USA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    importantInfo: '',
    open: false,
    latitude: 39.9122,
    longitude: -105.0505,
    serviceTerritoryId: '0Hhcr0000000UFpCAM',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'SP1446',
        name: null,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo: 'Closed 5/26',
        availability: [
          {
            days: 'Monday - Friday',
            hours: '9:10am - 1:00pm, 1:30pm - 5:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'ont',
    name: 'Ontario International Airport - ONT',
    address1: '2500 E Airport Drive',
    address2: null,
    zip: '91761',
    city: 'Ontario',
    state: 'CA',
    country: 'USA',
    type: 'airport',
    parking:
      'Parking is located across from the terminal. Hourly and daily parking are available. Onsite and offsite parking are also available.',
    importantInfo: null,
    open: true,
    latitude: 34.056,
    longitude: -117.5981,
    serviceTerritoryId: '0Hhcr0000000aptCAA',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'ont',
        name: 'Terminal 2',
        description:
          'Located on the ground floor main entrance across from Alaska Airlines. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo: null,
        availability: [
          {
            days: null,
            hours: '6:00am - 7:00pm',
          },
        ],
      },
      {
        id: '2',
        locationUid: 'ont',
        name: 'Terminal 4',
        description:
          'Located on ground floor main entrance across from Southwest Airlines. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo: null,
        availability: [
          {
            days: 'Sunday - Monday and Thursday',
            hours: '6:00am - 7:00pm',
          },
          {
            days: 'Tuesday - Wednesday',
            hours: '6:00am - 6:30pm',
          },
          {
            days: 'Saturday',
            hours: '6:00am - 5:30pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'SP0025',
    name: 'Staples - Bensalem, PA',
    address1: '2329 Street Rd',
    address2: null,
    zip: '19020',
    city: 'Bensalem',
    state: 'PA',
    country: 'USA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    importantInfo: null,
    open: false,
    latitude: 40.1048,
    longitude: -74.9482,
    serviceTerritoryId: '0Hhcr0000000U7lCAE',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'SP0025',
        name: null,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo:
          'Memorial Day Hours of Operation: 10:10am - 1:00pm, 1:30pm - 5:00pm',
        availability: [
          {
            days: 'Monday - Friday',
            hours: '9:10am - 1:00pm, 1:30pm - 5:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'SP1102',
    name: 'Staples - Frisco, TX',
    address1: '3333 Preston Road',
    address2: null,
    zip: '75034',
    city: 'Frisco',
    state: 'TX',
    country: 'USA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    importantInfo: null,
    open: false,
    latitude: 33.107,
    longitude: -96.8134,
    serviceTerritoryId: '0Hhcr0000000TRpCAM',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'SP1102',
        name: null,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo: 'Closed 5/26',
        availability: [
          {
            days: 'Monday - Friday',
            hours: '9:10am - 1:00pm, 1:30pm - 5:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'SP1108',
    name: 'Staples - Middletown, RI',
    address1: '898 West Main Rd',
    address2: null,
    zip: '02842',
    city: 'Middletown',
    state: 'RI',
    country: 'USA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    importantInfo: null,
    open: false,
    latitude: 41.5271,
    longitude: -71.2996,
    serviceTerritoryId: '0Hhcr0000000Xs1CAE',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'SP1108',
        name: null,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo:
          'Memorial Day Hours of Operation: 10:10am - 1:00pm, 1:30pm - 5:00pm',
        availability: [
          {
            days: 'Monday - Friday',
            hours: '9:10am - 1:00pm, 1:30pm - 5:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'SP1471',
    name: 'Staples - N Las Vegas, NV',
    address1: '6960 North 5th St N',
    address2: null,
    zip: '89084',
    city: 'Las Vegas',
    state: 'NV',
    country: 'USA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    importantInfo: null,
    open: false,
    latitude: 36.28705,
    longitude: -115.1328,
    serviceTerritoryId: '0Hhcr0000000eblCAA',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'SP1471',
        name: null,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo: 'Closed 5/26',
        availability: [
          {
            days: 'Thursday - Saturday',
            hours: '9:10am - 1:00pm, 1:30pm - 5:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'atl',
    name: 'Hartsfield-Jackson Atlanta International Airport - ATL',
    address1: '6000 N Terminal Pkwy',
    address2: null,
    zip: '30320',
    city: 'Atlanta',
    state: 'GA',
    country: 'USA',
    type: 'airport',
    parking:
      'Parking is located across from the terminal. Hourly and daily parking are available. Onsite and offsite parking are also available.',
    importantInfo: null,
    open: true,
    latitude: 33.640411,
    longitude: -84.419853,
    serviceTerritoryId: '0Hhcr0000000WcbCAE',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'atl',
        name: 'Main Terminal',
        description:
          'Located on the North side on the Departure level, near the security checkpoint entrance. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: false,
        accessibilityMessage:
          'Accessible pod is available at Main Terminal - South',
        availability: [
          {
            days: null,
            hours: '6:00am - 8:00pm',
          },
        ],
      },
      {
        id: '2',
        locationUid: 'atl',
        name: 'International Terminal',
        description:
          'Located inside of the door D1 on the Departure level. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo: null,
        availability: [
          {
            days: null,
            hours: '6:00am - 8:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'SP0348',
    name: 'Staples - Bellingham, MA',
    address1: '284 Hartford Ave',
    address2: null,
    zip: '02019',
    city: 'Bellingham',
    state: 'MA',
    country: 'USA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    importantInfo: null,
    open: false,
    latitude: 42.1164,
    longitude: -71.4615,
    serviceTerritoryId: '0Hhcr0000000SFdCAM',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'SP0348',
        name: null,
        description:
          'Located in the Travel Services section. Enter through the front vestibule, turn left and walk all the way to the back. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo: 'Closed 5/26',
        availability: [
          {
            days: 'Monday - Friday',
            hours: '9:10am - 1:00pm, 1:30pm - 5:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'SP1187',
    name: 'Staples - Ft. Worth, TX',
    address1: '1660 S. University Drive',
    address2: null,
    zip: '76107',
    city: 'Ft. Worth',
    state: 'TX',
    country: 'USA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    importantInfo: null,
    open: false,
    latitude: 32.72702,
    longitude: -97.3619,
    serviceTerritoryId: '0Hhcr0000000fuPCAQ',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'SP1187',
        name: null,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo:
          'Memorial Day Hours of Operation: 10:10am - 12:00pm, 12:30pm - 6:00pm',
        availability: [
          {
            days: 'Monday - Friday',
            hours: '9:10am - 1:00pm, 1:30pm - 5:00pm',
          },
          {
            days: 'Beginning 5/6',
            hours: null,
          },
          {
            days: 'Monday - Wednesday',
            hours: '8:10am - 12:00pm, 12:30pm - 7:00pm',
          },
          {
            days: 'Thursday - Friday',
            hours: '9:10am - 1:00pm, 1:30pm - 5:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'cvg',
    name: 'Cincinnati/Northern Kentucky International Airport - CVG',
    address1: '3087 Terminal Dr',
    address2: null,
    zip: '41048',
    city: 'Hebron',
    state: 'KY',
    country: 'USA',
    type: 'airport',
    parking:
      'Parking is located across from the terminal. Hourly and daily parking are available. Onsite and offsite parking are also available.',
    importantInfo: null,
    open: true,
    latitude: 39.0514,
    longitude: -84.6671,
    serviceTerritoryId: '0Hhcr0000000aujCAA',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'cvg',
        name: 'Main Terminal',
        description:
          'Located on the Departures level near the security checkpoint. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: false,
        accessibilityMessage:
          'Accessible pod is available at Main Terminal, Rent-A-Car (RAC) enrollment location.',
        availability: [
          {
            days: null,
            hours: '6:00am - 7:30pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'SP1900',
    name: 'Staples - Lincoln, NE',
    address1: '4940 O Street',
    address2: null,
    zip: '68510',
    city: 'Lincoln',
    state: 'NE',
    country: 'USA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    importantInfo: null,
    open: false,
    latitude: 40.814008,
    longitude: -96.6516,
    serviceTerritoryId: '0Hhcr0000000i97CAA',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'SP1900',
        name: null,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo: 'Closed 5/26',
        availability: [
          {
            days: 'Monday - Friday',
            hours: '9:10am - 1:00pm, 1:30pm - 5:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'dca',
    name: 'Ronald Reagan Washington National Airport - DCA',
    address1: '2401 Smith Boulevard',
    address2: null,
    zip: '22202',
    city: 'Arlington',
    state: 'VA',
    country: 'USA',
    type: 'airport',
    parking:
      'Parking is located across from the terminal. Hourly and daily parking are available. Onsite and offsite parking are also available.',
    importantInfo: null,
    open: true,
    latitude: 38.8512,
    longitude: -77.0402,
    serviceTerritoryId: '0Hhcr0000000ahpCAA',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'dca',
        name: 'Terminal 2',
        description:
          'Located near the main security checkpoint next to American Airlines ticketing counter. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo: null,
        availability: [
          {
            days: 'Sunday - Friday',
            hours: '6:00am - 9:00pm',
          },
          {
            days: 'Saturday',
            hours: '6:00am - 7:30pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'buf',
    name: 'Buffalo Niagara International Airport - BUF',
    address1: '4200 Genesee St',
    address2: null,
    zip: '14225',
    city: 'Buffalo',
    state: 'NY',
    country: 'USA',
    type: 'airport',
    parking:
      'Parking is located across from the terminal. Hourly and daily parking are available. Onsite and offsite parking are also available.',
    importantInfo: null,
    open: true,
    latitude: 42.9413,
    longitude: -78.7303,
    serviceTerritoryId: '0Hhcr0000000a57CAA',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'buf',
        name: 'Main Terminal',
        description:
          'Located on the Departures level in front of the security checkpoint entrance. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo: null,
        availability: [
          {
            days: null,
            hours: '4:00am - 7:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'SP0051',
    name: 'Staples - Saugus, MA',
    address1: '444 Broadway (Route 1)',
    address2: null,
    zip: '01906',
    city: 'Saugus',
    state: 'MA',
    country: 'USA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    importantInfo: null,
    open: false,
    latitude: 42.50203,
    longitude: -71.0147,
    serviceTerritoryId: '0Hhcr0000000fkjCAA',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'SP0051',
        name: null,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo:
          'Memorial Day Hours of Operation: 10:10am - 1:00pm, 1:30pm - 5:00pm',
        availability: [
          {
            days: 'Monday - Friday',
            hours: '9:10am - 1:00pm, 1:30pm - 5:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'SP1254',
    name: 'Staples - Lake Worth, TX',
    address1: '6313 Lake Worth Blvd Lake',
    address2: null,
    zip: '76135',
    city: 'Worth',
    state: 'TX',
    country: 'USA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    importantInfo: null,
    open: false,
    latitude: 32.8093,
    longitude: -97.4237,
    serviceTerritoryId: '0Hhcr0000001Ja5CAE',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'SP1254',
        name: null,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo: 'Closed 5/26',
        availability: [
          {
            days: 'Monday - Friday',
            hours: '10:10am - 2:00pm, 2:30pm - 5:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'SP0630',
    name: 'Staples - Norco, CA',
    address1: '1210 Hammer Ave',
    address2: null,
    zip: '92860',
    city: 'Norco',
    state: 'CA',
    country: 'USA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    importantInfo: null,
    open: false,
    latitude: 33.9003,
    longitude: -117.5645,
    serviceTerritoryId: '0Hhcr0000000XQbCAM',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'SP0630',
        name: null,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo:
          'Memorial Day Hours of Operation: 10:10am - 1:00pm, 1:30pm - 5:00pm',
        availability: [
          {
            days: 'Monday - Tuesday & Thursday - Friday',
            hours: '9:10am - 1:00pm, 1:30pm - 5:00pm',
          },
          {
            days: 'Wednesday & Sunday',
            hours: 'Closed',
          },
          {
            days: 'Saturday',
            hours: '10:00am - 1:00pm, 1:30pm - 6:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'SP1390',
    name: 'Staples - Gardena, CA',
    address1: '701 West Redondo Beach Blvd',
    address2: null,
    zip: '90247',
    city: 'Gardena',
    state: 'CA',
    country: 'USA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    importantInfo: null,
    open: false,
    latitude: 33.8926,
    longitude: -118.2876,
    serviceTerritoryId: '0Hhcr0000000d9RCAQ',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'SP1390',
        name: null,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo:
          'Memorial Day Hours of Operation: 10:10am - 1:00pm, 1:30pm - 5:00pm',
        availability: [
          {
            days: 'Monday - Friday',
            hours: '9:10am - 1:00pm, 1:30pm - 5:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'SP0054',
    name: 'Staples - Stamford, CT',
    address1: '2299 Summer St',
    address2: null,
    zip: '06905',
    city: 'Stamford',
    state: 'CT',
    country: 'USA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    importantInfo: null,
    open: false,
    latitude: 41.06805,
    longitude: -73.54607,
    serviceTerritoryId: '0Hhcr0000000iInCAI',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'SP0054',
        name: null,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo: null,
        availability: [
          {
            days: 'Monday - Tuesday & Thursday - Friday',
            hours: '10:10am - 2:00pm, 2:30pm - 6:00pm',
          },
          {
            days: 'Saturday',
            hours: '9:10am - 1:00pm, 1:30pm - 5:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'SP0123',
    name: 'Staples - Wyomissing, PA',
    address1: '1167 Berkshire Blvd',
    address2: null,
    zip: '19610',
    city: 'Wyomissing',
    state: 'PA',
    country: 'USA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    importantInfo: '',
    open: false,
    latitude: 40.3412,
    longitude: -75.978,
    serviceTerritoryId: '0Hhcr0000000VDVCA2',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'SP0123',
        name: null,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo:
          'Memorial Day Hours of Operation: 10:10am - 1:00pm, 1:30pm - 5:00pm',
        availability: [
          {
            days: 'Monday - Friday',
            hours: '10:10am - 2:00pm, 2:30pm - 6:00pm',
          },
          {
            days: 'Beginning 5/13',
            hours: null,
          },
          {
            days: 'Monday - Friday',
            hours: '9:10am - 1:00pm, 1:30pm - 5:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'LSM',
    name: 'CLEAR Lenox Square',
    address1: '3393 Peachtree St',
    address2: null,
    zip: '30326',
    city: 'Atlanta',
    state: 'GA',
    country: 'USA',
    type: 'flagship',
    parking: 'Parking is available at the mall.',
    importantInfo: null,
    open: false,
    latitude: 33.8145,
    longitude: -84.3916,
    serviceTerritoryId: '0Hhcr0000000cjdCAA',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'LSM',
        name: null,
        description:
          'Located on the 1st floor across from the UGG and Adidas stores. Enter via the main entrance and proceed straight ahead. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo: null,
        availability: [
          {
            days: 'Monday - Saturday',
            hours: '10:00am - 2:00pm, 2:30pm - 4:30pm, 5:00pm - 7:00pm',
          },
          {
            days: 'Sunday',
            hours: '12:00pm - 2:00pm, 2:30pm - 4:30pm, 5:00pm - 7:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'SP0036',
    name: 'Staples - Waltham, MA',
    address1: '800 Lexington St',
    address2: null,
    zip: '02452',
    city: 'Waltham',
    state: 'MA',
    country: 'USA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    importantInfo: null,
    open: false,
    latitude: 42.4025,
    longitude: -71.2345,
    serviceTerritoryId: '0Hhcr0000000eofCAA',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'SP0036',
        name: null,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo: 'Closed 5/26',
        availability: [
          {
            days: 'Monday - Friday',
            hours: '9:10am - 1:00pm, 1:30pm - 5:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'SP1144',
    name: 'Staples - Tulsa, OK',
    address1: '10302 East 71th South',
    address2: null,
    zip: '74133',
    city: 'Tulsa',
    state: 'OK',
    country: 'USA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    importantInfo: null,
    open: false,
    latitude: 36.0588,
    longitude: -95.8611,
    serviceTerritoryId: '0Hhcr0000000iQrCAI',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'SP1144',
        name: 'Main Terminal',
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo: 'Closed 5/26',
        availability: [
          {
            days: 'Monday - Friday',
            hours: '9:10am - 1:00pm, 1:30pm - 5:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'psp',
    name: 'Palm Springs International Airport - PSP',
    address1: '3400 E Tahquitz Canyon Way',
    address2: null,
    zip: '92262',
    city: 'Palm Springs',
    state: 'CA',
    country: 'USA',
    type: 'airport',
    parking:
      'Parking is located across from the terminal. Hourly and daily parking are available. Onsite and offsite parking are also available.',
    importantInfo: null,
    open: true,
    latitude: 33.8303,
    longitude: -116.507,
    serviceTerritoryId: '0Hhcr0000000a8LCAQ',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'psp',
        name: 'Main Terminal',
        description:
          'Located to the right of the main entrance door. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo: null,
        availability: [
          {
            days: null,
            hours: '6:00am - 5:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'SP0236',
    name: 'Staples - Fall River, MA',
    address1: '816 William S Canning Blvd',
    address2: null,
    zip: '02721',
    city: 'Fall River',
    state: 'MA',
    country: 'USA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    importantInfo: null,
    open: false,
    latitude: 41.6714,
    longitude: -71.1598,
    serviceTerritoryId: '0Hhcr0000000VBtCAM',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'SP0236',
        name: null,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo:
          'Memorial Day Hours of Operation: 10:10am - 1:00pm, 1:30pm - 5:00pm',
        availability: [
          {
            days: 'Monday, Wednesday - Friday',
            hours: '9:10am - 1:00pm, 1:30pm - 5:00pm',
          },
          {
            days: 'Tuesday & Sunday',
            hours: 'Closed',
          },
          {
            days: 'Saturday',
            hours: '10:00am - 1:00pm, 1:30pm - 6:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'STL',
    name: 'St. Louis Lambert International Airport - STL',
    address1: '10701 Lambert International Blvd',
    address2: null,
    zip: '63145',
    city: 'St. Louis',
    state: 'MO',
    country: 'USA',
    type: 'airport',
    parking:
      'Parking is located across from the terminal. Hourly and daily parking are available. Onsite and offsite parking are also available.',
    importantInfo: null,
    open: true,
    latitude: 38.7424,
    longitude: -90.3642,
    serviceTerritoryId: '0Hhcr0000000f81CAA',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'STL',
        name: 'Terminal 2',
        description:
          'Located inside the upper level of Terminal 2 near Door 2 and 3. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: false,
        accessibilityMessage:
          'Accessible pod is available at Terminal 1, Checkpoint A',
        availability: [
          {
            days: 'Monday - Sunday',
            hours: '6:00am - 7:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'SP1092',
    name: 'Staples - Daytona Beach, FL',
    address1: '2500 W International Speedway Blvd',
    address2: 'Suite 900',
    zip: '32114',
    city: 'Daytona Beach',
    state: 'FL',
    country: 'USA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    importantInfo: null,
    open: false,
    latitude: 29.1797,
    longitude: -81.0837,
    serviceTerritoryId: '0Hhcr0000000iFZCAY',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'SP1092',
        name: null,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo:
          'Memorial Day Hours of Operation: 10:10am - 1:00pm, 1:30pm - 5:00pm',
        availability: [
          {
            days: 'Monday - Friday',
            hours: '9:10am - 1:00pm, 1:30pm - 5:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'SP0336',
    name: 'Staples - West Los Angeles, CA',
    address1: '2052 Bundy Drive West',
    address2: null,
    zip: '90025',
    city: 'Los Angeles',
    state: 'CA',
    country: 'USA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    importantInfo: null,
    open: false,
    latitude: 34.03306,
    longitude: -118.4539,
    serviceTerritoryId: '0Hhcr0000000g7JCAQ',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'SP0336',
        name: null,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo: 'Closed 5/26',
        availability: [
          {
            days: 'Monday - Friday',
            hours: '9:10am - 1:00pm, 1:30pm - 5:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'SP0093',
    name: 'Staples - Cypress, CA',
    address1: '6816 Katella Ave',
    address2: null,
    zip: '90630',
    city: 'Cypress',
    state: 'CA',
    country: 'USA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    importantInfo: null,
    open: false,
    latitude: 33.8027,
    longitude: -118.0144,
    serviceTerritoryId: '0Hhcr0000000TQDCA2',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'SP0093',
        name: null,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo: 'Closed 5/26',
        availability: [
          {
            days: 'Monday - Tuesday & Thursday - Saturday',
            hours: '9:10am - 1:00pm, 1:30pm - 5:00pm',
          },
          {
            days: 'Wednesday & Sunday',
            hours: 'Closed',
          },
        ],
      },
    ],
  },
  {
    uid: 'SP1427',
    name: 'Staples - Los Angeles, CA',
    address1: '11341 National Blvd',
    address2: null,
    zip: '90064',
    city: 'Los Angeles',
    state: 'CA',
    country: 'USA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    importantInfo: null,
    open: false,
    latitude: 34.0262,
    longitude: -118.4328,
    serviceTerritoryId: '0Hhcr0000000feHCAQ',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'SP1427',
        name: null,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo: 'Closed 5/26',
        availability: [
          {
            days: 'Monday - Friday',
            hours: '9:10am - 1:00pm, 1:30pm - 5:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'sat',
    name: 'San Antonio International Airport - SAT',
    address1: '9800 Airport Blvd',
    address2: null,
    zip: '78216',
    city: 'San Antonio',
    state: 'TX',
    country: 'USA',
    type: 'airport',
    parking:
      'Parking is located across from the terminal. Hourly and daily parking are available. Onsite and offsite parking are also available.',
    importantInfo: null,
    open: true,
    latitude: 29.5268,
    longitude: -98.4721,
    serviceTerritoryId: '0Hhcr0000000a6jCAA',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'sat',
        name: 'Terminal A',
        description:
          'Located on the main security level near the security checkpoint entrance. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: false,
        accessibilityMessage:
          'Accessible pod is available at Terminal B, Security Level.',
        availability: [
          {
            days: null,
            hours: '6:00am - 7:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'SP1021',
    name: 'Staples - Cranberry Township, PA',
    address1: '1675 Route 228',
    address2: null,
    zip: '16066',
    city: 'Cranberry Township',
    state: 'PA',
    country: 'USA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    importantInfo: null,
    open: false,
    latitude: 40.6869,
    longitude: -80.0788,
    serviceTerritoryId: '0Hhcr0000000UCbCAM',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'SP1021',
        name: null,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo:
          'Memorial Day Hours of Operation: 10:10am - 1:00pm, 1:30pm - 5:00pm',
        availability: [
          {
            days: 'Monday - Friday',
            hours: '9:10am - 1:00pm, 1:30pm - 5:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'BWI',
    name: 'Baltimore/Washington International Thurgood Marshall Airport - BWI',
    address1: '7050 Friendship Rd',
    address2: null,
    zip: '21240',
    city: 'Baltimore',
    state: 'MD',
    country: 'USA',
    type: 'airport',
    parking:
      'Parking is located across from the terminal. Hourly and daily parking are available. Onsite and offsite parking are also available.',
    importantInfo: null,
    open: true,
    latitude: 39.1794,
    longitude: -76.6685,
    serviceTerritoryId: '0Hhcr0000000eBxCAI',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'BWI',
        name: null,
        description:
          'Located on the security level to the right of Checkpoint B, next to the Skywalk B near door 6. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo: null,
        availability: [
          {
            days: null,
            hours: '6:00am - 8:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'SP0497',
    name: 'Staples - Glendale, CA',
    address1: '213 North Glendale Ave',
    address2: null,
    zip: '91206',
    city: 'Glendale',
    state: 'CA',
    country: 'USA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    importantInfo: null,
    open: false,
    latitude: 34.1485,
    longitude: -118.2482,
    serviceTerritoryId: '0Hhcr0000000UAzCAM',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'SP0497',
        name: 'Main Terminal, Checkpoint B',
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo: 'Closed 5/26',
        availability: [
          {
            days: 'Monday - Friday',
            hours: '9:10am - 1:00pm, 1:30pm - 5:00pm',
          },
          {
            days: 'Saturday',
            hours: '10:00am - 1:00pm, 1:30pm - 6:00pm',
          },
          {
            days: 'Sunday',
            hours: '10:00am - 1:00pm, 1:30pm - 6:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'SP1365',
    name: 'Staples - Concord, CA',
    address1: '4498 Treat Blvd',
    address2: null,
    zip: '94521',
    city: 'Concord',
    state: 'CA',
    country: 'USA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    importantInfo: null,
    open: false,
    latitude: 37.9636,
    longitude: -121.9922,
    serviceTerritoryId: '0Hhcr0000000g8vCAA',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'SP1365',
        name: null,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo: 'Closed 5/26',
        availability: [
          {
            days: 'Tuesday - Saturday',
            hours: '9:10am - 1:00pm, 1:30pm - 5:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'SP1386',
    name: 'Staples - Downey, CA',
    address1: '12070 Lakewood Blvd',
    address2: null,
    zip: '90242',
    city: 'Downey',
    state: 'CA',
    country: 'USA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    importantInfo: null,
    open: false,
    latitude: 33.9261,
    longitude: -118.1264,
    serviceTerritoryId: '0Hhcr0000000isHCAQ',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'SP1386',
        name: null,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo: 'Closed 5/26',
        availability: [
          {
            days: 'Thursday - Monday',
            hours: '10:10am - 2:00pm, 2:30pm - 6:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'SP0632',
    name: 'Staples - Provo, UT',
    address1: '971 S University Dr',
    address2: null,
    zip: '84601',
    city: 'Provo',
    state: 'UT',
    country: 'USA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    importantInfo: null,
    open: false,
    latitude: 40.2208,
    longitude: -111.6575,
    serviceTerritoryId: '0Hhcr0000000g2TCAQ',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'SP0632',
        name: null,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo:
          'Memorial Day Hours of Operation: 10:10am - 1:00pm, 1:30pm - 5:00pm, Closed 6/6',
        availability: [
          {
            days: 'Tuesday - Saturday',
            hours: '9:10am - 1:00pm, 1:30pm - 5:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'DHL020',
    name: 'DHL - North Miami, FL',
    address1: '1825 NE 163rd St',
    address2: 'Ste A',
    zip: '33162',
    city: 'North Miami Beach',
    state: 'FL',
    country: 'USA',
    type: 'dhl',
    parking: 'Parking is available in front of the retail building.',
    importantInfo: null,
    open: false,
    latitude: 25.92603,
    longitude: -80.1624,
    serviceTerritoryId: '0Hhcr0000003RgPCAU',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'DHL020',
        name: null,
        description:
          'Located inside the store entrance, in front of the checkout counter. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo: 'Closed 5/26',
        availability: [
          {
            days: 'Monday  - Friday',
            hours: '9:10am - 11:50pm, 12:30pm - 4:50pm',
          },
          {
            days: 'Saturday',
            hours: '10:00am - 1:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'DHL015',
    name: 'DHL - Coral Gables, FL',
    address1: '226 Almeria Ave',
    address2: null,
    zip: '33134',
    city: 'Coral Gables',
    state: 'FL',
    country: 'USA',
    type: 'dhl',
    parking: 'Parking is available in front of the retail building.',
    importantInfo: null,
    open: false,
    latitude: 25.7468,
    longitude: -80.2593,
    serviceTerritoryId: '0Hhcr0000003S1NCAU',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'DHL015',
        name: null,
        description:
          'Located inside the store entrance, in front of the checkout counter. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo: 'Closed 5/26',
        availability: [
          {
            days: 'Monday  - Friday',
            hours: '9:10am - 11:50pm, 12:30pm - 4:50pm',
          },
          {
            days: 'Saturday',
            hours: '10:00am - 1:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'SP0587',
    name: 'Staples - Hixson, TN - Planned Opening May 24th',
    address1: '5450 Highway 153',
    address2: 'Suite 126',
    zip: '37343',
    city: 'Hixson',
    state: 'TN',
    country: 'USA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    importantInfo: null,
    open: false,
    latitude: 35.1403,
    longitude: -85.2483,
    serviceTerritoryId: '',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'SP0587',
        name: null,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo: null,
        availability: [
          {
            days: 'Saturday',
            hours: '10:10am - 2:00pm, 2:30pm - 6:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'SP1267',
    name: 'Staples - Lithonia, GA',
    address1: '8170 Mail Parkway',
    address2: null,
    zip: '30028',
    city: 'Lithonia',
    state: 'GA',
    country: 'USA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    importantInfo: null,
    open: false,
    latitude: 33.6928,
    longitude: -84.0924,
    serviceTerritoryId: '0Hhcr0000000gnFCAQ',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'SP1267',
        name: null,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo: 'Closed 5/22 & 5/26',
        availability: [
          {
            days: 'Monday - Friday',
            hours: '9:10am - 1:00pm, 1:30pm - 5:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'SP0102',
    name: 'Staples - Jersey City, NJ',
    address1: '701 State Route 440',
    address2: 'Space 16',
    zip: '07304',
    city: 'Jersey City',
    state: 'NJ',
    country: 'USA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    importantInfo: null,
    open: false,
    latitude: 40.7212,
    longitude: -74.0952,
    serviceTerritoryId: '0Hhcr0000000gs5CAA',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'SP0102',
        name: null,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo: 'Closed 5/26',
        availability: [
          {
            days: 'Monday - Tuesday, Thursday - Friday',
            hours: '10:10am - 2:00pm, 2:30pm - 6:00pm',
          },
          {
            days: 'Saturday',
            hours: '10:00am - 2:00pm, 2:30pm - 6:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'SP0178',
    name: 'Staples - Burlington, MA',
    address1: '111 Middlesex Turnpike',
    address2: null,
    zip: '01803',
    city: 'Burlington',
    state: 'MA',
    country: 'USA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    importantInfo: null,
    open: false,
    latitude: 42.4866,
    longitude: -71.2204,
    serviceTerritoryId: '0Hhcr0000000gthCAA',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'SP0178',
        name: null,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo:
          'Memorial Day Hours of Operation: 10:10am - 1:00pm, 1:30pm - 5:00pm',
        availability: [
          {
            days: 'Monday - Friday',
            hours: '9:10am - 1:00pm, 1:30pm - 5:00pm',
          },
          {
            days: 'Saturday',
            hours: '10:10am - 2:00pm, 2:30pm - 6:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'SP0953',
    name: 'Staples - New York, NY',
    address1: '5 Union Square West',
    address2: 'FRNT 1',
    zip: '10003',
    city: 'New York',
    state: 'NY',
    country: 'USA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    importantInfo: null,
    open: false,
    latitude: 40.7357,
    longitude: -73.9918,
    serviceTerritoryId: '0Hhcr0000004QwnCAE',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'SP0953',
        name: null,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo: 'Closed 5/26',
        availability: [
          {
            days: 'Monday - Friday',
            hours: '10:10am - 2:00pm, 2:30pm - 6:00pm',
          },
          {
            days: 'Saturday',
            hours: '11:00am - 3:00pm, 3:30pm - 7:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'SP1031',
    name: 'Staples - Oviedo, FL',
    address1: '1950 W. State Road',
    address2: '426',
    zip: '32765',
    city: 'Oviedo',
    state: 'FL',
    country: 'USA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    importantInfo: null,
    open: false,
    latitude: 28.6539,
    longitude: -81.2283,
    serviceTerritoryId: '0Hhcr0000000gwvCAA',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'SP1031',
        name: null,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo:
          'Memorial Day Hours of Operation: 10:10am - 2:00pm, 2:30pm - 5:00pm',
        availability: [
          {
            days: 'Monday - Saturday',
            hours: '10:10am - 2:00pm, 2:30pm - 6:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'SP0801',
    name: 'Staples - Roseville, CA',
    address1: '6770 Stanford Branch Rd',
    address2: null,
    zip: '95678',
    city: 'Roseville',
    state: 'CA',
    country: 'USA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    importantInfo: null,
    open: false,
    latitude: 38.7806,
    longitude: -121.2658,
    serviceTerritoryId: '0Hhcr0000000gyXCAQ',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'SP0801',
        name: null,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo:
          'Memorial Day Hours of Operation: 10:10am - 1:00pm, 1:30pm - 5:00pm',
        availability: [
          {
            days: 'Monday - Friday',
            hours: '9:10am - 1:00pm, 1:30pm - 5:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'SP1410',
    name: 'Staples - Santa Rosa, CA',
    address1: '2222 Cleveland Ave',
    address2: null,
    zip: '95403',
    city: 'Santa Rosa',
    state: 'CA',
    country: 'USA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    importantInfo: null,
    open: false,
    latitude: 38.46109,
    longitude: -122.7276,
    serviceTerritoryId: '0Hhcr0000000h09CAA',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'SP1410',
        name: null,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo: 'Closed 5/26',
        availability: [
          {
            days: 'Monday - Friday',
            hours: '9:10am - 1:00pm, 1:30pm - 5:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'SP1794',
    name: 'Staples - Huntersville, NC',
    address1: '10031 Biddick Lane',
    address2: null,
    zip: '28078',
    city: 'Huntersville',
    state: 'NC',
    country: 'USA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    importantInfo: null,
    open: false,
    latitude: 35.4433,
    longitude: -80.8575,
    serviceTerritoryId: '0Hhcr0000001JTdCAM',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'SP1794',
        name: null,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo: 'Closed 5/22, 5/26, 6/17 - 6/20, 6/24 - 6/25',
        availability: [
          {
            days: 'Monday - Friday',
            hours: '9:10am - 1:00pm, 1:30pm - 5:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'SP0705',
    name: 'Staples - Uniontown, PA',
    address1: '3 Work Parkway',
    address2: null,
    zip: '15401',
    city: 'Uniontown',
    state: 'PA',
    country: 'USA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    importantInfo: null,
    open: false,
    latitude: 39.9035,
    longitude: -79.7528,
    serviceTerritoryId: '0Hhcr0000001urNCAQ',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'SP0705',
        name: null,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo: 'Closed 5/26',
        availability: [
          {
            days: 'Monday - Friday',
            hours: '9:10am - 1:00pm, 1:30pm - 5:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'SP0372',
    name: 'Staples - Chesterfield, MI - Planned Opening May 27th',
    address1: '51382 Gratiot Ave',
    address2: null,
    zip: '48051',
    city: 'Chesterfield',
    state: 'MI',
    country: 'USA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    importantInfo: null,
    open: false,
    latitude: 42.6767,
    longitude: -82.8288,
    serviceTerritoryId: '',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'SP0372',
        name: null,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo: null,
        availability: [
          {
            days: 'Monday - Friday',
            hours: '9:10am - 1:00pm, 1:30pm - 5:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'SP0535',
    name: 'Staples - Raleigh, NC - Planned Opening May 27th',
    address1: '3064 Wake Forest Road',
    address2: null,
    zip: '27609',
    city: 'Raleigh',
    state: 'NC',
    country: 'USA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    importantInfo: null,
    open: false,
    latitude: 35.8233,
    longitude: -78.6203,
    serviceTerritoryId: '',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'SP0535',
        name: null,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo: null,
        availability: [
          {
            days: 'Monday - Friday',
            hours: '9:10am - 1:00pm, 1:30pm - 5:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'SP0001',
    name: 'Staples - Brighton, MA - Planned Opening May 27th',
    address1: '1660 Soldiers Field Road',
    address2: null,
    zip: '02135',
    city: 'Brighton',
    state: 'MA',
    country: 'USA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    importantInfo: null,
    open: false,
    latitude: 42.3587,
    longitude: -71.1533,
    serviceTerritoryId: '',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'SP0001',
        name: null,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo: null,
        availability: [
          {
            days: 'Monday - Friday',
            hours: '9:10am - 1:00pm, 1:30pm - 5:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'SP0746',
    name: 'Staples - New York, NY - Planned Opening May 27th',
    address1: '2248 Broadway',
    address2: null,
    zip: '10024',
    city: 'New York',
    state: 'NY',
    country: 'USA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    importantInfo: null,
    open: false,
    latitude: 40.7847,
    longitude: -73.9788,
    serviceTerritoryId: '',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'SP0746',
        name: null,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo: null,
        availability: [
          {
            days: 'Monday - Friday',
            hours: '9:10am - 1:00pm, 1:30pm - 5:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'SP1134',
    name: 'Staples - Cincinnati, OH - Planned Opening May 27th',
    address1: '3808 Paxton Ave',
    address2: 'No 14A',
    zip: '45209',
    city: 'Cincinnati',
    state: 'OH',
    country: 'USA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    importantInfo: null,
    open: false,
    latitude: 39.1461,
    longitude: -84.4284,
    serviceTerritoryId: '',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'SP1134',
        name: null,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo: null,
        availability: [
          {
            days: 'Monday - Friday',
            hours: '9:10am - 1:00pm, 1:30pm - 5:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'SP1337',
    name: 'Staples - Burien (Seattle), WA - Planned Opening May 27th',
    address1: '158 SW 148th St',
    address2: null,
    zip: '98166',
    city: 'Burien (Seattle)',
    state: 'WA',
    country: 'USA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    importantInfo: null,
    open: false,
    latitude: 47.4708,
    longitude: -122.3369,
    serviceTerritoryId: '',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'SP1337',
        name: null,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo: null,
        availability: [
          {
            days: 'Monday - Friday',
            hours: '9:10am - 1:00pm, 1:30pm - 5:00pm',
          },
        ],
      },
    ],
  },
  {
    uid: 'SP1653',
    name: 'Staples - Southlake, TX - Planned Opening May 27th',
    address1: '200 N Kimball Ave',
    address2: 'Suite 221',
    zip: '76092',
    city: 'Southlake',
    state: 'TX',
    country: 'USA',
    type: 'staples',
    parking: 'Parking is available in front of the retail building.',
    importantInfo: null,
    open: false,
    latitude: 32.9416,
    longitude: -97.1189,
    serviceTerritoryId: '',
    isTestLocation: false,
    lanes: [
      {
        id: '1',
        locationUid: 'SP1653',
        name: null,
        description:
          'Located in the Travel Services section, enter through the front vestibule. Look for TSA PreCheck and CLEAR signage.',
        isAccessible: true,
        accessibilityMessage: null,
        importantInfo: null,
        availability: [
          {
            days: 'Monday - Friday',
            hours: '9:10am - 1:00pm, 1:30pm - 5:00pm',
          },
        ],
      },
    ],
  },
]
